import React, { PureComponent, useState, useEffect } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { loadModules } from 'esri-loader';
import Select from 'react-select';
import { findAllEstado } from "../../Services/EstadoService";
import { findCidadeByEstado } from "../../Services/CidadeService";
import { findAllSubstanciaByEnabled } from "../../Services/SubstanciaService";
import { hasAccess, hasGroupAccess } from "../../Services/SecurityService";
import {
    findAllGeometryShapesByEstadoSemCor,
    searchGeometryShapes
} from "../../Services/GeometryShapes";
import {
    findAllGeometryShapeRequerimentosIntersectsByCidade,
    findAllGeometryShapesRequerimentoWithoutCity,
    findAllGeometryShapeRequerimentosIntersectsByCidadeVizinha
}
    from "../../Services/GeometryShapesRequerimentos";
import { findAllGeometryAreaByCidade, findAllGeometryAreaByCidadeVizinha } from "../../Services/GeometryShapesCidadeArea";
import { findAllGeometryAreaByEstado } from "../../Services/GeometryShapesEstadoArea";
import {
    findAllGeometryShapeCavernas,
    findAllGeometryShapeCavernasIntersectsByCidade,
    findAllGeometryShapeCavernasIntersectsByEstado
} from "../../Services/GeometryShapesCavernasService";

import {
    findAllGeometryShapeProtecaoIntegral,
    findAllGeometryShapeProtecaoIntegralIntersectsByCidade,
    findAllGeometryShapeProtecaoIntegralIntersectsByEstado
} from "../../Services/GeometryShapesProtecaoIntegralService";
import {
    findAllGeometryShapeQuilombolas,
    findAllGeometryShapeQuilombolasIntersectsByCidade,
    findAllGeometryShapeQuilombolasIntersectsByEstado
} from "../../Services/GeometryShapesQuilombolasService";
import {
    findAllGeometryShapeSitiosArqueologicos,
    findAllGeometryShapeSitiosArqueologicosIntersectsByCidade,
    findAllGeometryShapeSitiosArqueologicosIntersectsByEstado
} from "../../Services/GeometryShapesSitiosArqueologicosService";
import {
    findAllGeometryShapeTerrasIndigenas,
    findAllGeometryShapeTerrasIndigenasIntersectsByCidade,
    findAllGeometryShapeTerrasIndigenasIntersectsByEstado
} from "../../Services/GeometryShapesTerrasIndigenasService";
import {
    findAllGeometryShapeUsoSustentavel,
    findAllGeometryShapeUsoSustentavelIntersectsByCidade,
    findAllGeometryShapeUsoSustentavelIntersectsByEstado
} from "../../Services/GeometryShapesUsoSustentavelService";
import { saveRequirement, saveBuffer, findAllBuffersByUser, findAllRequirementsByUser } from "../../Services/GeometryUserService";
import { util } from "../../../shared/util";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';
import { environment } from '../../environment';
import { db } from '../../db';

let notificationTC = null;

const styles = {
    container: {
        padding: 0,
        margin: 0,
        height: '93vh',
        width: '100%'
    },
    options: {
        top: '50px',
        color: '#444',
        height: 'auto',
        fontFamily: 'arial',
        right: '20px',
        margin: '5px',
        padding: '10px',
        position: 'absolute',
        width: '115px',
        zIndex: '40',
        border: 'solid 2px #666',
        borderRadius: '4px',
        backgroundColor: '#fff'
    },
    button: {
        display: 'block'
    }
}
const options = { css: true };


let totalGraphics = 0;
let symbolsMap = [];
let symbolDestaque = null;
let creteSymbol = null;
let creteSymbolOk = null;
let invalidSymbol = null;
let allOthers = null;

//VIEW's and LAYER's
var view = null;
var graphicsLayer = null;
var requirementLayer = null;
var requirementLayer2 = null;
var geologyLayer = null;
var geologyLayer2 = null;
var cityLayer = null;
var cityVizinhaLayer = null;
var stateLayer = null;

var placesProtecaoIntegralLayer = null;
var placesQuilombolasLayer = null;
var placesTerrasIndigenasLayer = null;
var placesUsoSustentavelLayer = null;
var markersCavesLayer = null;
var markersSitiosLayer = null;

var gpsLayer = null;

let polygonList = null;
let polygonListIndex = -1;
let polygonListMaxIndex = -1;


//PERMISSIONS
let prefeiturasAdministradores = false;
let prefeituras = false;
let searchPlace_OK = false;
let searchPanel_OK = false;
let settingsPanel_OK = false;
let cityChangePanel_OK = false;
let cityInfoPanel_OK = false;
let substance_OK = false;
let state_OK = false;
let city_OK = false;
let brazil_OK = false;
let requirement_OK = false;
let requirementLayer_OK = false;
let buffer_OK = false;
let point_OK = false;
let popupInfoView_OK = false;


//MODAL's
let expandSettings = null;
let expandSearch = null;
let expandRequerimento = null;
let expandLegend = null;
let sketch = null;
let expandBuffer = null;
let expandChangeCity = null;
let expandCityInfo = null;
let expandGpsOrPoint = null;


let user = null;
let cidadeInfo = null;
let estados = [];
let userOrgaoValido = true;
let moreThanOneCity = false;
let bufferSize = 50;
let searchProccessValue = '';
let dmsValue = '';
let xyValue = '';

let dmsValueG_lat = '';
let dmsValueM_lat = '';
let dmsValueS_lat = '';
let dmsValueZ_lat = 'S';
let dmsValueG_long = '';
let dmsValueM_long = '';
let dmsValueS_long = '';
let dmsValueZ_long = 'W';

let selectedGraphics = [];
const defaultRings = [
    [-4314568.517849945, -1446662.7018698684],
    [-4314568.517849945, -1439324.7471545013],
    [-4307230.563134579, -1439324.7471545013],
    [-4307230.563134579, -1446662.7018698684],
    [-4314568.517849945, -1446662.7018698684]
];

let pointImg = `${process.env.PUBLIC_URL}/img/pointImg.png`;
let cavernaImg = `${process.env.PUBLIC_URL}/img/cavernaImg.png`;
let sitiosImg = `${process.env.PUBLIC_URL}/img/sitiosImg.png`;
let gpsImg = `${process.env.PUBLIC_URL}/img/ico_gps.gif`;
let loadingImg = `${process.env.PUBLIC_URL}/img/loading.gif`;
let info_01 = `${process.env.PUBLIC_URL}/img/info_01.png`;
let info_02 = `${process.env.PUBLIC_URL}/img/info_02.png`;



let loadingCanto = false;
let loadingCentro = false;


class ArcGisMap extends PureComponent {
    static propTypes = {
        t: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            subsList: [],
            selectedSubs: [],
            substancias: [],
            selectedSubstancias: [],

            estados: [],
            statesList: [],
            selectedStates: [{ value: 0, label: this.props.t('forms.loading') + "..." }],
            selectedEstados: [],

            cidades: [],
            citiesList: [],
            selectedCities: [],
            selectedCidades: [],


            allRequirements: [],
            requirementsList: [],
            selectedRequirements: [{ value: 0, label: this.props.t('forms.loading') + "..." }],
            selectedRequirementsObj: [],


            allBuffers: [],
            buffersList: [],
            selectedBuffers: [{ value: 0, label: this.props.t('forms.loading') + "..." }],
            selectedBuffersObj: [],



            cidadeInfo: {},


            longList: [{ value: "E", label: "Leste" }, { value: "W", label: "Oeste" }],
            selectedLong: [{ value: "W", label: "Oeste" }],
            latList: [{ value: "S", label: "Sul" }, { value: "N", label: "Norte" }],
            selectedLat: [{ value: "S", label: "Sul" }],

            typeArea: { value: "acres", label: "Acres" },
            typeAreaList: [
                { value: "acres", label: "Acres" },
                { value: "hectares", label: "Hectares" },
                // {value: "miles", label: "Milhas"},
                // {value: "kilometers", label: "Quilometros"},
                // {value: "meters", label: "Metros"}
            ],

            data: {
                popupInfoView: false,
                cavernasView: false,
                sitiosArqueologicosView: false,
                protecaoIntegralView: false,
                quilombolasView: false,
                terrasIndigenasView: false,
                usoSustentavalView: false,
                requerimentoView: true,
                geologiaView: false,
                geologiaBordaView: false,
                cidadeView: true,
                cidadeVizinhaView: true,
                estadoView: false,
                requerimentoNameSave: '',
                bufferNameSave: '',
                bufferSize: 50,
                searchProccessValue: '',
                dmsValue: '',
                dmsValueG_lat: '',
                dmsValueM_lat: '',
                dmsValueS_lat: '',
                dmsValueZ_lat: 'S',
                dmsValueG_long: '',
                dmsValueM_long: '',
                dmsValueS_long: '',
                dmsValueZ_long: 'W',
                xyValue: '',
            },

            refresh: 1,

            status: 'loading'
        };
    }


    configCidade(cidadeObj = null) {
        let cidadeAux = null;
        if (prefeiturasAdministradores || prefeituras) {
            if (cidadeObj !== null) {
                if (estados.length > 0) {
                    for (let i = 0; i < estados.length; i++) {
                        if (estados[i].cidades.length > 0) {
                            for (let j = 0; j < estados[i].cidades.length; j++) {
                                if (estados[i].cidades[j].id === cidadeObj.id) {
                                    cidadeAux = cidadeObj;
                                    break;
                                }
                            }
                        }
                        if (cidadeAux != null) {
                            cidadeInfo = cidadeAux;
                            break;
                        }
                    }
                }
            } else {
                if (estados.length > 0) {
                    for (let i = 0; i < estados.length; i++) {
                        if (estados[i].cidades.length > 0) {
                            for (let j = 0; j < estados[i].cidades.length; j++) {
                                if (estados[i].cidades[j].id === user.cidade.id) {
                                    cidadeAux = user.cidade;
                                    break;
                                }
                            }
                        }
                        if (cidadeAux != null) {
                            cidadeInfo = cidadeAux;
                            break;
                        }
                    }
                }
                if (cidadeInfo === null) {
                    cidadeInfo = estados[0].cidades[0];
                }
            }
        } else {
            if (cidadeObj !== null) {
                cidadeInfo = cidadeObj;
            } else {
                cidadeInfo = user.cidade;
            }
        }
        this.configMap();
    }

    loadCidades(estado, cidade) {
        let options = [];
        let cidades = [];
        let selectedCities = [];
        moreThanOneCity = false;

        if (prefeiturasAdministradores || prefeituras) {
            let countCity = 0;

            if (estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length > 0) {
                for (let i = 0; i < this.state.estados.length; i++) {
                    if (this.state.estados[i].id === estado.id) {
                        cidades = this.state.estados[i].cidades;
                        if (cidades !== undefined && cidades !== null && cidades.length > 0) {
                            for (let i = 0; i < cidades.length; i++) {
                                options.push({ value: cidades[i].id, label: cidades[i].name });
                            }
                        }
                        countCity += estados[i].cidades.length;
                    } else {
                        if (this.state.estados[i].cidades !== null && this.state.estados[i].cidades !== undefined && this.state.estados[i].cidades.length > 0) {
                            countCity += estados[i].cidades.length;
                        }
                    }
                }
                if (countCity > 0) {
                    if (countCity > 1) {
                        moreThanOneCity = true;
                    }
                    this.setState({
                        cidades,
                        citiesList: options,
                        selectedCities
                    }, () => {
                        if (cidade !== null) {
                            this.setCidade(cidade);
                        }
                    });
                } else {
                    userOrgaoValido = false;
                }
            } else {
                userOrgaoValido = false;
            }
        } else {
            moreThanOneCity = true;
            findCidadeByEstado(estado.id)
                .then(response => {
                    if (response === undefined) {
                        response = [];
                    }
                    if (response !== undefined && response.error === undefined) {
                        cidades = response;
                        if (cidades !== undefined && cidades !== null && cidades.length > 0) {
                            for (let i = 0; i < cidades.length; i++) {
                                options.push({ value: cidades[i].id, label: cidades[i].name });
                            }
                        }
                    } else {
                        if (response.errors === undefined) {
                            response = [];
                            this.show('danger', this.props.t('forms.errorListData'));
                        } else {
                            response = [];
                            this.show('danger', response.errors[0].defaultMessage);
                        }
                    }
                    this.setState({
                        cidades,
                        citiesList: options,
                        selectedCities
                    }, () => {
                        if (cidade !== null) {
                            this.setCidade(cidade);
                        }
                    });
                });
        }
    }

    setCidade(cidade) {
        let selectedCities = [];
        let selectedCidades = [];
        if (cidade !== null) {
            for (let i = 0; i < this.state.cidades.length; i++) {
                if (this.state.cidades[i].id === cidade.id) {
                    selectedCities.push({ value: this.state.cidades[i].id, label: this.state.cidades[i].name });
                    selectedCidades.push(this.state.cidades[i]);
                    break;
                }
            }
        }
        this.setState({ selectedCities, selectedCidades }, () => { });
    }

    loadEstado() {
        if (prefeiturasAdministradores || prefeituras) {
            let options = [];
            let estados = environment.getUserStateCities();

            if (estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0) {
                for (let i = 0; i < estados.length; i++) {
                    options.push({ value: estados[i].id, label: estados[i].name });
                }
                this.setState({
                    estados,
                    statesList: options
                }, () => {
                    let user = environment.getUser();
                    if (user !== null && user.cidade !== undefined && user.cidade !== null && user.cidade.id !== null) {
                        this.setEstado(user.cidade.estado, user.cidade);
                    }
                });
            }
        } else {
            findAllEstado()
                .then(response => {
                    if (response === undefined) {
                        response = [];
                    }
                    let options = [];
                    let estados = [];
                    if (response !== undefined && response.error === undefined) {
                        estados = response;
                        if (estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0) {
                            for (let i = 0; i < estados.length; i++) {
                                options.push({ value: estados[i].id, label: estados[i].name });
                            }
                            this.setState({
                                estados,
                                statesList: options
                            }, () => {
                                let user = environment.getUser();
                                if (user !== null && user.cidade !== undefined && user.cidade !== null && user.cidade.id !== null) {
                                    this.setEstado(user.cidade.estado, user.cidade);
                                }
                            });
                        }
                    } else {
                        if (response.errors === undefined) {
                            response = [];
                            this.show('danger', this.props.t('forms.errorListData'));
                        } else {
                            response = [];
                            this.show('danger', response.errors[0].defaultMessage);
                        }
                    }
                });
        }
    }

    setEstado(estado, cidade) {
        let selectedStates = [];
        let selectedEstados = [];
        let citiesList = [];
        let selectedCities = [];
        let selectedCidades = [];

        if (estado !== null) {
            for (let e = 0; e < this.state.estados.length; e++) {
                if (this.state.estados[e].id === estado.id) {
                    selectedStates.push({ value: this.state.estados[e].id, label: this.state.estados[e].name });
                    selectedEstados.push(this.state.estados[e]);
                    selectedCities.push({ value: 0, label: this.props.t('forms.loading') + "..." });
                    break;
                }
            }
        }
        this.setState({ selectedStates, selectedEstados, citiesList, selectedCities, selectedCidades }, () => {
            if (selectedEstados.length > 0) {
                this.loadCidades(estado, cidade);
            }
        });
    }

    loadSubstancia() {
        findAllSubstanciaByEnabled(0)
            .then(data => {
                if (data === undefined) {
                    data = [];
                }
                if (data !== undefined && data.error === undefined) {
                    let options = [];
                    if (data !== undefined && data !== null && data.length > 0 && this.state.substancias.length === 0) {
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].id !== 344) {//Dado Não Cadastrado
                                options.push({ value: data[i].id, label: data[i].name });
                            }
                        }
                        this.setState({
                            subsList: options,
                            substancias: data
                        });
                    }
                } else {
                    if (data.errors === undefined) {
                        data = [];
                        this.show('danger', this.props.t('forms.errorListData'));
                    } else {
                        data = [];
                        this.show('danger', data.errors[0].defaultMessage);
                    }
                }
            });
    }

    show = (color, message, duration = 5) => {
        return notificationTC.notice({
            content: <FullWideNotification
                color={color}
                message={message}
            />,
            duration: duration,
            closable: true,
            style: { top: 0, left: 0 },
            className: `full ltr-support`,
        });
    };

    //national-geographic, oceans, terrain, topo-vector, topo
    componentDidMount() {
        NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);

        if (util.getDeviceType() === 'mobile') {
            window.history.pushState('/forms/home', 'MinerBook', '/forms/home');
        }
        // alert(navigator.userAgent + " " + util.getDeviceType());
        // alert(util.getDeviceType());


        prefeiturasAdministradores = hasGroupAccess("PREFEITURAS_ADMINISTRADORES");
        prefeituras = hasGroupAccess("PREFEITURAS");

        searchPlace_OK = hasAccess("MENU_MAP_SEARCH_PLACE");
        searchPanel_OK = hasAccess("MENU_MAP_GEOLOGY_SEARCH_PANEL");
        settingsPanel_OK = hasAccess("MENU_MAP_GEOLOGY_SETTINGS_PANEL");
        cityChangePanel_OK = hasAccess("MENU_MAP_GEOLOGY_CITY_PANEL");
        cityInfoPanel_OK = hasAccess("MENU_MAP_GEOLOGY_CITY_INFO");
        substance_OK = hasAccess("MENU_MAP_GEOLOGY_SEARCH_PANEL_SUBSTANCE");
        state_OK = hasAccess("MENU_MAP_GEOLOGY_SEARCH_PANEL_STATE");
        city_OK = hasAccess("MENU_MAP_GEOLOGY_SEARCH_PANEL_CITY");
        brazil_OK = hasAccess("MENU_MAP_GEOLOGY_SEARCH_PANEL_ALL_BRAZIL");
        requirement_OK = hasAccess("MENU_MAP_CREATE_REQUIREMENT");
        requirementLayer_OK = hasAccess("MENU_REQUIREMENT_VIEW_MAP");
        buffer_OK = hasAccess("MENU_MAP_CREATE_BUFFER");//
        point_OK = hasAccess("MENU_MAP_CREATE_POINT");//



        user = environment.getUser();
        estados = environment.getUserStateCities();

        this.loadEstado();
        this.loadSubstancia();

        loadModules([
            "esri/Map",
            "esri/views/MapView",
            "esri/widgets/Expand",
            "esri/widgets/Search",
            // "esri/views/draw/Draw",
            "esri/geometry/coordinateFormatter",
            "esri/widgets/Sketch",
            "esri/symbols/SimpleLineSymbol",
            "esri/symbols/SimpleFillSymbol",
            "esri/layers/GraphicsLayer",
            //   "esri/tasks/Locator",
            "esri/Basemap",
            "esri/widgets/BasemapGallery",
            "esri/widgets/BasemapToggle",
            "esri/widgets/Zoom",
            "esri/widgets/Fullscreen",
            "esri/geometry/projection",
            "esri/geometry/SpatialReference",
            "esri/core/watchUtils"
            //   "dojo/domReady"], options)
        ], options)
            .then(([Map, MapView, Expand, Search, coordinateFormatter, Sketch,
                SimpleLineSymbol, SimpleFillSymbol, GraphicsLayer,
                //   Locator, 
                Basemap, BasemapGallery,
                BasemapToggle, Zoom,
                Fullscreen, projection, SpatialReference, watchUtils]) => {

                //esriConfig.apiKey = "YOUR-API-KEY";

                var map = new Map({
                    basemap: "streets"
                });

                view = new MapView({
                    center: [-50.70281064022086, -10.477802433502271],
                    container: "viewDiv",
                    map: map,
                    zoom: 4
                    //spatialReference: SpatialReference.WGS84
                });
                view.popup.autoOpenEnabled = false;

                stateLayer = new GraphicsLayer();
                stateLayer.title = "stateLayer";
                stateLayer.visible = false;
                map.add(stateLayer);

                cityVizinhaLayer = new GraphicsLayer();
                cityVizinhaLayer.title = "cityVizinhaLayer";
                map.add(cityVizinhaLayer);

                cityLayer = new GraphicsLayer();
                cityLayer.title = "cityLayer";
                map.add(cityLayer);

                geologyLayer = new GraphicsLayer();
                geologyLayer.title = "geologyLayer";
                geologyLayer.visible = false;
                map.add(geologyLayer);

                geologyLayer2 = new GraphicsLayer();
                geologyLayer2.title = "geologyLayer2";
                geologyLayer2.visible = false;
                map.add(geologyLayer2);

                placesProtecaoIntegralLayer = new GraphicsLayer();
                placesProtecaoIntegralLayer.title = "placesProtecaoIntegralLayer";
                placesProtecaoIntegralLayer.visible = false;
                map.add(placesProtecaoIntegralLayer);

                placesQuilombolasLayer = new GraphicsLayer();
                placesQuilombolasLayer.title = "placesQuilombolasLayer";
                placesQuilombolasLayer.visible = false;
                map.add(placesQuilombolasLayer);

                placesTerrasIndigenasLayer = new GraphicsLayer();
                placesTerrasIndigenasLayer.title = "placesTerrasIndigenasLayer";
                placesTerrasIndigenasLayer.visible = false;
                map.add(placesTerrasIndigenasLayer);

                placesUsoSustentavelLayer = new GraphicsLayer();
                placesUsoSustentavelLayer.title = "placesUsoSustentavelLayer";
                placesUsoSustentavelLayer.visible = false;
                map.add(placesUsoSustentavelLayer);

                requirementLayer = new GraphicsLayer();
                requirementLayer.title = "requirementLayer";
                map.add(requirementLayer);

                requirementLayer2 = new GraphicsLayer();
                requirementLayer2.title = "requirementLayer2";
                map.add(requirementLayer2);

                markersCavesLayer = new GraphicsLayer();
                markersCavesLayer.title = "markersCavesLayer";
                markersCavesLayer.visible = false;
                map.add(markersCavesLayer);

                markersSitiosLayer = new GraphicsLayer();
                markersSitiosLayer.title = "markersSitiosLayer";
                markersSitiosLayer.visible = false;
                map.add(markersSitiosLayer);

                graphicsLayer = new GraphicsLayer();
                graphicsLayer.title = "graphicsLayer";
                map.add(graphicsLayer);

                gpsLayer = new GraphicsLayer();
                gpsLayer.title = "gpsLayer";
                map.add(gpsLayer);


                // load the coordinate formatter module
                coordinateFormatter.load();


                view.ui.components = ["attribution"];

                view.ui.add(document.getElementById("panelCityChangeVazioBtn"), "top-left");
                // view.ui.add(document.getElementById("panelCityChangeVazio2Btn"), "top-left");

                if (requirementLayer_OK) {
                    expandLegend = new Expand({
                        view: view,
                        content: document.getElementById("requerimentoLegendBtn"),
                        expanded: false,
                        closeOnEsc: false,
                        collapseIconClass: "esri-icon-collapse",
                        expandIconClass: "esri-icon-legend", //esri-icon-notice-round
                        expandTooltip: "Legenda dos Registros Minerais",
                        collapseTooltip: "Recolher"
                    });
                    view.ui.add(expandLegend, "top-left");
                }

                if (settingsPanel_OK) {
                    expandSettings = new Expand({
                        view: view,
                        content: document.getElementById("panelSettingBtn"),
                        expanded: false,
                        closeOnEsc: false,
                        collapseIconClass: "esri-icon-collapse",
                        expandIconClass: "esri-icon-layers",
                        expandTooltip: "Camadas",
                        collapseTooltip: "Recolher"
                    });
                    view.ui.add(expandSettings, "top-left");
                }

                if (searchPanel_OK) {
                    expandSearch = new Expand({
                        view: view,
                        content: document.getElementById("panelSearchBtn"),
                        expanded: false,
                        closeOnEsc: false,
                        collapseIconClass: "esri-icon-collapse",
                        expandIconClass: "esri-icon-experimental",//esri-icon-globe esri-icon-experimental
                        expandTooltip: "Pesquisar Geologias",
                        collapseTooltip: "Recolher"
                        //label: "Label"
                    });
                    view.ui.add(expandSearch, "top-left");
                }

                if (cityChangePanel_OK && moreThanOneCity) {
                    expandChangeCity = new Expand({
                        view: view,
                        content: document.getElementById("panelCityChangeBtn"),
                        expanded: false,
                        closeOnEsc: false,
                        collapseIconClass: "esri-icon-collapse",
                        expandIconClass: "esri-icon-applications",
                        expandTooltip: "Mudar Cidade",
                        collapseTooltip: "Recolher",
                        label: "panelCityChangeBtn"
                    });
                    view.ui.add(expandChangeCity, "top-left");
                }

                view.ui.add(document.getElementById("panelInfoBtn"), "top-left");

                if (cityInfoPanel_OK) {
                    expandCityInfo = new Expand({
                        view: view,
                        content: document.getElementById("panelCityInfoBtn"),
                        expanded: false,
                        closeOnEsc: false,
                        collapseIconClass: "esri-icon-collapse",
                        expandIconClass: "esri-icon-home",
                        expandTooltip: "Dados da Cidade",
                        collapseTooltip: "Recolher"
                        //label: "Label"
                    });
                    view.ui.add(expandCityInfo, "bottom-left");
                }

                expandGpsOrPoint = new Expand({
                    view: view,
                    content: document.getElementById("gpsBtn"),
                    expanded: false,
                    closeOnEsc: false,
                    collapseIconClass: "esri-icon-collapse",
                    expandIconClass: "esri-icon-locate",
                    expandTooltip: "Localizar ponto no mapa",
                    collapseTooltip: "Recolher"
                    //label: "Label"
                });
                view.ui.add(expandGpsOrPoint, "bottom-left");

                // view.ui.add(document.getElementById("loadingIco"), "bottom-left");


                if (searchPlace_OK) {
                    const search = new Search({
                        view: view
                    });
                    view.ui.add(search, "top-right");
                }

                sketch = new Sketch({
                    layer: graphicsLayer,
                    view: view,
                    // graphic will be selected as soon as it is created
                    creationMode: "update",
                    visibleElements: {
                        createTools: {
                            circle: false
                        },
                        // selectionTools:{
                        //   "lasso-selection": false
                        // },
                        // settingsMenu: false
                    }
                });
                view.ui.add(sketch, "top-right");

                if (requirementLayer_OK) {
                    view.ui.add(document.getElementById("searchProccessDiv"), "top-right");
                }

                if (buffer_OK) {
                    expandBuffer = new Expand({
                        view: view,
                        content: document.getElementById("bufferBtn"),
                        expanded: false,
                        closeOnEsc: false,
                        collapseIconClass: "esri-icon-collapse",
                        expandIconClass: "esri-icon-measure-area",
                        expandTooltip: "Criar Buffer",
                        collapseTooltip: "Recolher"
                    });
                    view.ui.add(expandBuffer, "top-right");
                }

                if (requirement_OK) {
                    expandRequerimento = new Expand({
                        view: view,
                        content: document.getElementById("requerimentoBtn"),
                        expanded: false,
                        closeOnEsc: false,
                        collapseIconClass: "esri-icon-collapse",
                        expandIconClass: "esri-icon-sketch-rectangle",//esri-icon-sketch-rectangle esri-icon-maps esri-icon-cursor-marquee 
                        expandTooltip: "Requerimento de Área",
                        collapseTooltip: "Recolher"
                    });
                    view.ui.add(expandRequerimento, "top-right");
                }


                var zoom = new Zoom({
                    view: view
                });
                view.ui.add(zoom, "bottom-right");

                // var fullscreen = new Fullscreen({
                //   view: view
                // });
                // view.ui.add(fullscreen, "bottom-right");


                // var basemapGallery = new BasemapGallery({
                //   view: view,
                //   source: [Basemap.fromId("streets"), Basemap.fromId("topo-vector"), Basemap.fromId("hybrid")],
                //   container: document.createElement("div")
                // });
                // var bgExpand = new Expand({
                //   view: view,
                //   content: basemapGallery.domNode,
                //   container: "changeBaseMapDiv",
                //   expandIconClass: "esri-icon-basemap"
                // });
                // view.ui.add(bgExpand, "bottom-right");

                var basemapToggle = new BasemapToggle({
                    view: view,  // The view that provides access to the map's "streets-vector" basemap
                    nextBasemap: "hybrid"  // Allows for toggling to the "hybrid" basemap
                });
                view.ui.add(basemapToggle, "bottom-right");

                view.ui.add(document.getElementById("dmsPanelDiv"), "bottom-right");


                // const draw = new Draw({
                //   view: view
                // });

                // var locatorTask = new Locator({
                //   url: "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer"
                // });


                allOthers = new SimpleFillSymbol({ // ALL
                    color: [190, 232, 255, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var requerimentoPesquisa = new SimpleFillSymbol({//REQUERIMENTO DE PESQUISA
                    color: [255, 255, 190, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var requerimentoRegistroExtracao = new SimpleFillSymbol({//REQUERIMENTO DE REGISTRO DE EXTRAÇÃO
                    color: [215, 194, 158, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var requerimentoLicenciamento = new SimpleFillSymbol({//REQUERIMENTO DE LICENCIAMENTO
                    color: [211, 255, 190, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var requerimentoLavraGarimpeira = new SimpleFillSymbol({//REQUERIMENTO DE LAVRA GARIMPEIRA
                    color: [232, 190, 255, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var requerimentoLavra = new SimpleFillSymbol({//REQUERIMENTO DE LAVRA
                    color: [255, 127, 127, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var registroExtracao = new SimpleFillSymbol({//REGISTRO DE EXTRAÇÃO
                    color: [168, 112, 0, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var licenciamento = new SimpleFillSymbol({//LICENCIAMENTO
                    color: [120, 62, 97, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var lavraGarimpeira = new SimpleFillSymbol({//LAVRA GARIMPEIRA
                    color: [194, 158, 215, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                let disponibilidade = new SimpleFillSymbol({//DISPONIBILIDADE
                    color: [0, 191, 255, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var concessaoLavra = new SimpleFillSymbol({//CONCESSÃO DE LAVRA
                    color: [255, 85, 0, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                var autorizacaoPesquisa = new SimpleFillSymbol({//AUTORIZAÇÃO DE PESQUISA
                    color: [250, 196, 165, 0.5],
                    outline: {
                        color: [128, 128, 128],
                        width: 0.5
                    }
                });

                symbolDestaque = new SimpleLineSymbol({
                    color: [0, 255, 255],
                    width: 3
                });

                creteSymbol = new SimpleFillSymbol({
                    color: [150, 150, 150, 0.2],
                    outline: {
                        cap: "round",
                        color: [50, 50, 50],
                        width: 1
                    }
                });

                creteSymbolOk = new SimpleFillSymbol({
                    style: "diagonal-cross",
                    color: [32, 158, 49],
                    outline: {
                        cap: "round",
                        color: [50, 50, 50],
                        width: 1
                    }
                });

                invalidSymbol = new SimpleFillSymbol({
                    style: "diagonal-cross",
                    color: [255, 0, 0],
                    outline: {
                        cap: "round",
                        color: [50, 50, 50],
                        width: 1
                    }
                });

                if (cityChangePanel_OK && moreThanOneCity) {
                    watchUtils.when(expandChangeCity, 'expanded', function () {
                        if (requirement_OK) {
                            expandRequerimento.collapse();
                        }
                        if (requirementLayer_OK) {
                            expandLegend.collapse();
                        }
                        if (buffer_OK) {
                            expandBuffer.collapse();
                        }
                        if (searchPanel_OK) {
                            expandSearch.collapse();
                        }
                        if (settingsPanel_OK) {
                            expandSettings.collapse();
                        }
                    });
                }

                if (searchPanel_OK) {
                    watchUtils.when(expandSearch, 'expanded', function () {
                        if (cityChangePanel_OK && moreThanOneCity) {
                            expandChangeCity.collapse();
                        }
                        if (requirement_OK) {
                            expandRequerimento.collapse();
                        }
                        if (requirementLayer_OK) {
                            expandLegend.collapse();
                        }
                        if (buffer_OK) {
                            expandBuffer.collapse();
                        }
                        if (settingsPanel_OK) {
                            expandSettings.collapse();
                        }
                    });
                }

                if (settingsPanel_OK) {
                    watchUtils.when(expandSettings, 'expanded', function () {
                        if (cityChangePanel_OK && moreThanOneCity) {
                            expandChangeCity.collapse();
                        }
                        if (requirement_OK) {
                            expandRequerimento.collapse();
                        }
                        if (requirementLayer_OK) {
                            expandLegend.collapse();
                        }
                        if (buffer_OK) {
                            expandBuffer.collapse();
                        }
                        if (searchPanel_OK) {
                            expandSearch.collapse();
                        }
                    });
                }

                if (requirement_OK) {
                    watchUtils.when(expandRequerimento, 'expanded', function () {
                        if (cityChangePanel_OK && moreThanOneCity) {
                            expandChangeCity.collapse();
                        }
                        if (requirementLayer_OK) {
                            expandLegend.collapse();
                        }
                        if (buffer_OK) {
                            expandBuffer.collapse();
                        }
                        if (searchPanel_OK) {
                            expandSearch.collapse();
                        }
                        if (settingsPanel_OK) {
                            expandSettings.collapse();
                        }
                    });
                }
                if (requirementLayer_OK) {
                    watchUtils.when(expandLegend, 'expanded', function () {
                        if (cityChangePanel_OK && moreThanOneCity) {
                            expandChangeCity.collapse();
                        }
                        if (requirement_OK) {
                            expandRequerimento.collapse();
                        }
                        if (buffer_OK) {
                            expandBuffer.collapse();
                        }
                        if (searchPanel_OK) {
                            expandSearch.collapse();
                        }
                        if (settingsPanel_OK) {
                            expandSettings.collapse();
                        }
                    });
                }


                if (buffer_OK) {
                    watchUtils.when(expandBuffer, 'expanded', function () {
                        if (cityChangePanel_OK && moreThanOneCity) {
                            expandChangeCity.collapse();
                        }
                        if (requirement_OK) {
                            expandRequerimento.collapse();
                        }
                        if (requirementLayer_OK) {
                            expandLegend.collapse();
                        }
                        if (searchPanel_OK) {
                            expandSearch.collapse();
                        }
                        if (settingsPanel_OK) {
                            expandSettings.collapse();
                        }
                    });
                }


                symbolsMap = new Map();
                symbolsMap.set("1", allOthers);//Apto Para Disponibilidade
                symbolsMap.set("2", autorizacaoPesquisa);//Autorização De Pesquisa
                symbolsMap.set("3", concessaoLavra);//Concessão De Lavra
                symbolsMap.set("4", allOthers);//Dado Não Cadastrado
                symbolsMap.set("5", allOthers);//Direito De Requerer A Lavra
                symbolsMap.set("6", disponibilidade);//Disponibilidade
                symbolsMap.set("7", lavraGarimpeira);//Lavra Garimpeira
                symbolsMap.set("8", licenciamento);//Licenciamento
                symbolsMap.set("9", registroExtracao);//Registro De Extração
                symbolsMap.set("10", requerimentoLavra);//Requerimento De Lavra
                symbolsMap.set("11", requerimentoLavraGarimpeira);//Requerimento de Lavra Garimpeira
                symbolsMap.set("12", requerimentoLicenciamento);//Requerimento de Licenciamento
                symbolsMap.set("13", requerimentoPesquisa);//Requerimento de Pesquisa
                symbolsMap.set("14", requerimentoRegistroExtracao);//Requerimento de Registro de Extração


                view.on("click", function (event) {

                    if (popupInfoView_OK) {
                        var lat = Math.round(event.mapPoint.latitude * 1000) / 1000;
                        var lon = Math.round(event.mapPoint.longitude * 1000) / 1000;

                        var graphic = null;
                        var popupTitle = "";
                        var content = "";

                        view.hitTest(event).then(function (response) {
                            if (response.results.length) {
                                graphic = response.results[0].graphic;

                                if (graphic !== null && graphic.attributes !== null &&
                                    graphic.attributes !== undefined && graphic.attributes.type !== undefined) {

                                    if (graphic.attributes.uf != null) {
                                        popupTitle = graphic.attributes.uf;
                                    }
                                    if (graphic.attributes.processo != null) {
                                        if (popupTitle.length > 0) {
                                            popupTitle += " - PROCESSO " + graphic.attributes.processo;
                                        } else {
                                            popupTitle += "PROCESSO " + graphic.attributes.processo;
                                        }
                                    }

                                    if (graphic.attributes.type == "Geologia") {
                                        popupTitle = graphic.attributes.nomeUNID;
                                        content = "<p>Geologia</p><br />" +
                                            "<ul><li>simb1000: " + graphic.attributes.simb1000 + "</li>" +
                                            "<li>Sub Classe: " + (graphic.attributes.subClasse1 != null && graphic.attributes.subClasse1.length > 0 ? graphic.attributes.subClasse1 : '') + "</li>" +
                                            "<li>Litotipo: " + (graphic.attributes.lito1 != null && graphic.attributes.lito1.length > 0 ? graphic.attributes.lito1 : '') + "</li>" +
                                            "<li>Litotipo: " + (graphic.attributes.lito2 != null && graphic.attributes.lito2.length > 0 ? graphic.attributes.lito2 : '') + "</li>" +
                                            "<li>Litotipo: " + (graphic.attributes.clIdLITO != null && graphic.attributes.clIdLITO.length > 0 ? graphic.attributes.clIdLITO : '') + "</li>" +
                                            "<li>Descrição: " + (graphic.attributes.description != null && graphic.attributes.description.length > 0 ? graphic.attributes.description : '') + "</li></ul>";

                                    } else if (graphic.attributes.type == "Cidade") {
                                        popupTitle = graphic.attributes.obj.name + " - " + graphic.attributes.obj.estado.name;
                                        content = "<ul><li>Prefeito: " + graphic.attributes.obj.prefeito + " (" + graphic.attributes.obj.siglaPartidoPrefeito + ")</li>" +
                                            "<li>Vice-Prefeito: " + graphic.attributes.obj.vicePrefeito + " (" + graphic.attributes.obj.siglaPartidoVicePrefeito + ")</li>" +
                                            "<li>Clima: " + (graphic.attributes.obj.clima != null && graphic.attributes.obj.clima.id > 0 ? graphic.attributes.obj.clima.name : '') + "</li>" +
                                            "<li>Descrição clima: " + (graphic.attributes.obj.descriptionClima != null && graphic.attributes.obj.descriptionClima.length > 0 ? graphic.attributes.obj.descriptionClima : (graphic.attributes.obj.clima != null && graphic.attributes.obj.clima.id > 0 ? graphic.attributes.obj.clima.description : '')) + "</li>" +
                                            "<li>" + (graphic.attributes.obj.nivelHabilitadoLicenciamento > 0 ? "Município Habilitado Competência Municipal nível " + graphic.attributes.obj.nivelHabilitadoLicenciamento : "Município não Habilitado") + "</li></ul>";

                                    } else if (graphic.attributes.type == "Estado") {
                                        popupTitle = graphic.attributes.obj.uf + " - " + graphic.attributes.obj.name;
                                        content = "";

                                    } else if (graphic.attributes.type == "cavernas") {
                                        popupTitle = graphic.attributes.name;
                                        content = "<p>Caverna</p><br />" +
                                            "<ul><li>Código: " + graphic.attributes.code + "</li>" +
                                            "<li>Código externo: " + graphic.attributes.codeExterno + "</li>" +
                                            "<li>Cidade: " + graphic.attributes.cidade + "</li>" +
                                            "<li>Estado: " + graphic.attributes.estado.name + "</li>" +
                                            "<li>Localidade: " + graphic.attributes.localidade + "</li>" +
                                            "<li>Litologia: " + graphic.attributes.litologia + "</li>" +
                                            "<li>classificação: " + graphic.attributes.classificacao + "</li>" +
                                            "<li>Data: " + graphic.attributes.data + "</li>" +
                                            "<li>Validação: " + graphic.attributes.validacao + "</li>" +
                                            "<li>Fonte: " + graphic.attributes.bibliografia + "</li></ul>";

                                    } else if (graphic.attributes.type == "sitiosArqueologicos") {
                                        popupTitle = (graphic.attributes.name != null && graphic.attributes.name != undefined && graphic.attributes.name.length > 0 ? graphic.attributes.name : graphic.attributes.instituicao);
                                        content = "<p>Sítio Arqueológico</p><br />" +
                                            "<ul><li>Código: " + graphic.attributes.code + "</li>" +
                                            "<li>Cidade: " + graphic.attributes.cidade + "</li>" +
                                            "<li>Estado: " + graphic.attributes.estado.name + "</li>" +
                                            "<li>Instituição: " + graphic.attributes.instituicao + "</li>" +
                                            "<li>Responsável: " + graphic.attributes.responsavel + "</li>" +
                                            "<li>Área: " + graphic.attributes.area + "</li></ul>";

                                    } else if (graphic.attributes.type == "protecaoIntegral") {
                                        popupTitle = graphic.attributes.name;
                                        content = "<p>APA Integral</p><br />" +
                                            "<ul><li>Nome abreviado: " + graphic.attributes.nameAbreviado + "</li>" +
                                            "<li>Sigla: " + graphic.attributes.sigla + "</li>" +
                                            "<li>Tipo Unidade: " + graphic.attributes.tipoUnidade + "</li>" +
                                            "<li>Info: " + graphic.attributes.info + "</li>" +
                                            "<li>Ato legal: " + graphic.attributes.atoLegal + "</li>" +
                                            "<li>Ano criação: " + graphic.attributes.anoCriacao + "</li>" +
                                            "<li>Administração: " + graphic.attributes.administracao + "</li>" +
                                            "<li>Área: " + graphic.attributes.area + "</li>" +
                                            "<li>Acres: " + graphic.attributes.acres + "</li>" +
                                            "<li>Hectares: " + graphic.attributes.hectares + "</li>" +
                                            "<li>Perímetro: " + graphic.attributes.perimetro + "</li></ul>";

                                    } else if (graphic.attributes.type == "quilombolas") {
                                        popupTitle = graphic.attributes.comunidade;
                                        content = "<p>Quilombolas</p><br />" +
                                            "<ul><li>Código: " + graphic.attributes.code + "</li>" +
                                            "<li>Processo: " + graphic.attributes.processo + "</li>" +
                                            "<li>Cidade: " + graphic.attributes.cidade + "</li>" +
                                            "<li>Estado: " + graphic.attributes.estado.name + "</li>" +
                                            "<li>Comunidade: " + graphic.attributes.comunidade + "</li>" +
                                            "<li>data publicacao: " + graphic.attributes.dataPublicacao + "</li>" +
                                            "<li>data título: " + graphic.attributes.dataTitulo + "</li>" +
                                            "<li>Área: " + graphic.attributes.area + "</li>" +
                                            "<li>Perímetro: " + graphic.attributes.perimetro + "</li></ul>";

                                    } else if (graphic.attributes.type == "terrasIndigenas") {
                                        popupTitle = graphic.attributes.nameAbreviado;
                                        content = "<p>Terras Indigenas</p><br />" +
                                            "<ul><li>Nome: " + graphic.attributes.name + "</li>" +
                                            "<li>Nome Tribo: " + graphic.attributes.nameTi + "</li>" +
                                            "<li>Data situação: " + graphic.attributes.dataSituacao + "</li>" +
                                            "<li>Grupo étnico: " + graphic.attributes.grupoEtnico + "</li>" +
                                            "<li>Situação jurídica: " + graphic.attributes.situacaoJu + "</li></ul>";

                                    } else if (graphic.attributes.type == "usoSustentavel") {
                                        popupTitle = graphic.attributes.name;
                                        content = "<p>APA de Uso Sustentával</p><br />" +
                                            "<ul><li>Nome abreviado: " + graphic.attributes.nameAbreviado + "</li>" +
                                            "<li>Sigla: " + graphic.attributes.sigla + "</li>" +
                                            "<li>Tipo Unidade: " + graphic.attributes.tipoUnidade + "</li>" +
                                            "<li>Info: " + graphic.attributes.info + "</li>" +
                                            "<li>Ato legal: " + graphic.attributes.atoLegal + "</li>" +
                                            "<li>Ano criação: " + graphic.attributes.anoCriacao + "</li>" +
                                            "<li>Administração: " + graphic.attributes.administracao + "</li>" +
                                            "<li>Área: " + graphic.attributes.area + "</li>" +
                                            "<li>Acres: " + graphic.attributes.acres + "</li>" +
                                            "<li>Hectares: " + graphic.attributes.hectares + "</li>" +
                                            "<li>Perímetro: " + graphic.attributes.perimetro + "</li></ul>";

                                    } else {
                                        popupTitle = graphic.attributes.name;
                                        content = "<p>Registros Minerais</p><br />" +
                                            "<ul><li>PROCESSO: " + graphic.attributes.processo + "</li>" +
                                            "<li>NUMERO: " + graphic.attributes.numero + "</li>" +
                                            "<li>ANO: " + graphic.attributes.ano + "</li>" +
                                            "<li>FASE: " + graphic.attributes.fase + "</li>" +
                                            "<li>SUBS: " + graphic.attributes.subs + "</li>" +
                                            "<li>AREA_HA: " + graphic.attributes.area_ha + "</li>" +
                                            "<li>ULT_EVENTO: " + graphic.attributes.ult_evento + "</li>" +
                                            "<li>Uso: " + graphic.attributes.uso + "</li></ul>";
                                    }

                                    view.popup.open({
                                        title: popupTitle,
                                        location: event.mapPoint,
                                        content: content
                                    });
                                }
                            }
                        });
                    }

                });

                view.on("pointer-move", function (evt) {
                    if (!coordinateFormatter.isLoaded()) {
                        document.getElementById("coordinateString").innerHTML = "DMS: ";
                        return;
                    }

                    var point = view.toMap(evt);
                    const wgs84Point = projection.project(point, SpatialReference.WGS84);
                    if (wgs84Point) {
                        document.getElementById("coordinateString").innerHTML = "DMS: " +
                            coordinateFormatter.toLatitudeLongitude(wgs84Point, "dms", 3);
                    }
                });

                view.when(this.initUserSettings());
                // view.when(function(){});
            });
    }

    initUserSettings() {

        // this.getLocation();

        if (requirement_OK) {
            setTimeout(() => { document.getElementById("requerimentoBtn").style.display = "block"; }, 2000);
        }
        if (requirementLayer_OK) {
            setTimeout(() => { document.getElementById("requerimentoLegendBtn").style.display = "block"; }, 2000);
        }
        if (buffer_OK) {
            setTimeout(() => { document.getElementById("bufferBtn").style.display = "block"; }, 2000);
        }
        if (searchPanel_OK) {
            setTimeout(() => { document.getElementById("panelSearchBtn").style.display = "block"; }, 2000);
        }
        if (settingsPanel_OK) {
            setTimeout(() => { document.getElementById("panelSettingBtn").style.display = "block"; }, 2000);
        }
        if (cityChangePanel_OK && moreThanOneCity) {
            setTimeout(() => { document.getElementById("panelCityChangeBtn").style.display = "block"; }, 2000);
        }
        if (cityInfoPanel_OK) {
            setTimeout(() => { document.getElementById("panelCityInfoBtn").style.display = "block"; }, 2000);
        }
        setTimeout(() => { document.getElementById("gpsBtn").style.display = "block"; }, 2000);

        if (prefeiturasAdministradores || prefeituras) {
            if (userOrgaoValido) {
                this.configCidade();
            } else {
                this.show('danger', this.props.t('erros.erro_0063'), 10);
                this.show('danger', this.props.t('erros.erro_0064'), 15);
            }
        } else {
            this.configCidade();
        }

        loadModules([
            "esri/Graphic",
            "esri/geometry/geometryEngine",
            "esri/geometry/SpatialReference",
            "esri/symbols/PictureMarkerSymbol",
            "esri/geometry/projection"], options)
            .then(([Graphic, geometryEngine, SpatialReference, PictureMarkerSymbol, projection]) => {

                let intersects = false;
                let intersectsApaIntegral = false;

                sketch.on(["create"], function (event) {

                    // console.log("create");

                    if (event.state === "complete") {
                        let graphicsCreated = event.graphic;
                        if (graphicsCreated.geometry.type === "point") {
                            let g = new Graphic(
                                graphicsCreated.geometry.clone(),
                                new PictureMarkerSymbol({
                                    url: pointImg,
                                    width: "15px",
                                    height: "15px"
                                })
                            );
                            g.attributes = {
                                state: event.state,
                                uid: g.uid,
                                invalid: false,
                                cutted: false
                            };

                            graphicsLayer.graphics.add(g);
                            graphicsLayer.graphics.remove(graphicsCreated);
                            console.log(g);
                        } else {
                            if (graphicsCreated.geometry.type === "polyline") {
                                let paths = graphicsCreated.geometry.paths[0];
                                let path = [];
                                let oldPath = null;
                                let currentPath = null;
                                for (let i = 0; i < paths.length; i++) {
                                    if (oldPath === null) {
                                        oldPath = paths[i][0] + " " + paths[i][1];
                                        path.push(paths[i]);
                                    } else {
                                        currentPath = paths[i][0] + " " + paths[i][1];
                                        if (currentPath !== oldPath) {
                                            path.push(paths[i]);
                                        }
                                        oldPath = currentPath;
                                    }
                                }
                                graphicsCreated.geometry.paths[0] = path;
                            }
                            graphicsCreated.attributes = {
                                state: event.state,
                                uid: event.graphic.uid,
                                invalid: false,
                                cutted: false
                            }
                        }
                    }

                });

                sketch.on(["update", "undo", "redo", "delete"], function (event) {

                    // console.log("update", "undo", "redo", "delete");

                    for (let i = 0; i < event.graphics.length; i++) {
                        if (event.graphics[i].attributes !== undefined) {
                            event.graphics[i].attributes.state = event.state;

                            if (event.graphics[i].attributes.cutted && event.graphics[i].attributes.state === "active") {
                                event.graphics[i].attributes.cutted = false;
                            }
                        }
                    }

                    selectedGraphics = event.graphics;

                    if (event.type === "delete") {
                        for (let i = 0; i < selectedGraphics.length; i++) {
                            for (let j = (graphicsLayer.graphics.items.length - 1); j >= 0; j--) {
                                if (selectedGraphics[i].attributes.uid === graphicsLayer.graphics.items[j].attributes.uid) {
                                    graphicsLayer.graphics.remove(graphicsLayer.graphics.items[j]);
                                }
                            }
                        }
                        selectedGraphics = [];
                        if (requirement_OK) {
                            document.getElementById("requerimentoNameAreaLabelAcres").innerHTML = "Acres: ";
                            document.getElementById("requerimentoNameAreaLabelHc").innerHTML = "Hectares: ";
                        }
                    } else {
                        if (requirementLayer.graphics !== null && requirementLayer.graphics.items.length > 0) {
                            for (let i = 0; i < selectedGraphics.length; i++) {
                                let graphic = selectedGraphics[i];

                                if (graphic.geometry.type !== "point" && graphic.attributes !== undefined && !graphic.attributes.cutted) {
                                    if (graphic.geometry.type !== "point") {
                                        intersects = false;

                                        let geometry = projection.project(graphic.geometry, SpatialReference.WGS84);
                                        for (let r = 0; r < requirementLayer.graphics.items.length; r++) {
                                            intersects = geometryEngine.intersects(requirementLayer.graphics.items[r].geometry, geometry);
                                            if (intersects) {
                                                break;
                                            }
                                        }
                                        for (let r = 0; r < placesProtecaoIntegralLayer.graphics.items.length; r++) {
                                            intersectsApaIntegral = geometryEngine.intersects(placesProtecaoIntegralLayer.graphics.items[r].geometry, geometry);
                                            if (intersectsApaIntegral) {
                                                break;
                                            }
                                        }

                                        graphic.attributes.invalid = (intersects || intersectsApaIntegral);
                                        graphic.symbol = (intersects || intersectsApaIntegral) ? invalidSymbol : creteSymbol;
                                    }
                                }
                            }
                        }

                        if (
                            event.toolEventInfo &&
                            (event.toolEventInfo.type === "move-stop" || event.toolEventInfo.type === "reshape-stop")
                        ) {
                            // if (!intersects) {
                            //   sketch.complete();
                            // }
                        } else if (event.state === "complete") {
                            // if (intersects) {
                            //   // sketch.update([graphic], { tool: "move" });
                            // }
                            selectedGraphics = [];
                            if (requirement_OK) {
                                document.getElementById("requerimentoNameAreaLabelAcres").innerHTML = "Acres: ";
                                document.getElementById("requerimentoNameAreaLabelHc").innerHTML = "Hectares: ";
                            }
                        }
                    }
                });
            });
    }



    componentWillUnmount() {
        notificationTC.destroy();
    }








    centerMapCity(geometry) {
        if (geometry != null && geometry != undefined) {
            let opts = {
                duration: 3000  // Duration of animation will be 5 seconds
            };

            view.goTo({
                target: geometry
            }, opts).catch((error) => {
                if (error.name != "AbortError") {
                    console.error(error);
                }
            });
        }
    }

    centerGPS() {
        if (gpsLayer.graphics != null && gpsLayer.graphics != undefined && gpsLayer.graphics.items.length > 0) {
            let opts = {
                duration: 3000  // Duration of animation will be 5 seconds
            };

            view.goTo({
                target: gpsLayer.graphics.items[0].geometry,
                zoom: 13
            }, opts).catch((error) => {
                if (error.name != "AbortError") {
                    console.error(error);
                }
            });
        } else {
            this.getLocation();
        }
    }


    focusBboxPoint(prev = false, next = false, goTo = true) {
        let geometry = null;
        if (polygonListMaxIndex > -1) {
            if (prev) {
                polygonListIndex--;
                if (polygonListIndex < 0) {
                    polygonListIndex = polygonListMaxIndex;
                }
                geometry = polygonList[polygonListIndex];
            } else if (next) {
                polygonListIndex++;
                if (polygonListIndex > polygonListMaxIndex) {
                    polygonListIndex = 0;
                }
                geometry = polygonList[polygonListIndex];
            }

            if (geometry != null && geometry != undefined) {
                loadModules([
                    "esri/Graphic",
                    "esri/geometry/Polyline"], options)
                    .then(([Graphic, Polyline]) => {
                        geologyLayer2.graphics.removeAll();
                        geologyLayer2.graphics.add(
                            new Graphic({
                                geometry: new Polyline({
                                    paths: geometry.rings
                                }),
                                symbol: symbolDestaque
                            })
                        );
                    });

                if (goTo) {
                    let opts = {
                        duration: 3000
                    };

                    view.goTo({
                        target: geometry,
                        zoom: 11
                    }, opts).catch((error) => {
                        if (error.name != "AbortError") {
                            console.error(error);
                        }
                    });
                }
            }
        }
    }

    disableMap() {
        view.popup.dockEnabled = true;

        // Removes the zoom action on the popup
        view.popup.actions = [];

        // stops propagation of default behavior when an event fires
        function stopEvtPropagation(event) {
            event.stopPropagation();
        }

        // exlude the zoom widget from the default UI
        view.ui.components = ["attribution"];

        // disable mouse wheel scroll zooming on the view
        view.on("mouse-wheel", stopEvtPropagation);

        // disable zooming via double-click on the view
        view.on("double-click", stopEvtPropagation);

        // disable zooming out via double-click + Control on the view
        view.on("double-click", ["Control"], stopEvtPropagation);

        // disables pinch-zoom and panning on the view
        view.on("drag", stopEvtPropagation);

        // disable the view's zoom box to prevent the Shift + drag
        // and Shift + Control + drag zoom gestures.
        view.on("drag", ["Shift"], stopEvtPropagation);
        view.on("drag", ["Shift", "Control"], stopEvtPropagation);

        // prevents zooming with the + and - keys
        view.on("key-down", function (event) {
            const prohibitedKeys = ["+", "-", "Shift", "_", "=", "ArrowUp", "ArrowDown", "ArrowRight", "ArrowLeft"];
            const keyPressed = event.key;
            if (prohibitedKeys.indexOf(keyPressed) !== -1) {
                event.stopPropagation();
            }
        });
    }

    configMap() {
        if (cidadeInfo !== null && cidadeInfo.id > 0) {
            this.findGeometryAreaByCidade(cidadeInfo.id, true, true);

            if (requirementLayer_OK) {
                this.findAllGeometryShapeRequerimentosIntersects_ByCidade(cidadeInfo.id, symbolsMap, true);
                this.getAllRequirementsByUser();
            } else {
                if (buffer_OK) {
                    this.getAllBuffersByUser();
                }
            }
            // this.findAllGeometryShapesRequerimento_withoutCity(symbolsMap);

            if (markersCavesLayer.visible) {
                this.findAllGeometryShapeCavernasIntersects_ByCidade(cidadeInfo.id);
            }
            if (markersSitiosLayer.visible) {
                this.findAllGeometryShapeSitiosArqueologicosIntersects_ByCidade(cidadeInfo.id);
            }
            if (placesProtecaoIntegralLayer.visible) {
                this.findAllGeometryShapeProtecaoIntegralIntersects_ByCidade(cidadeInfo.id);
            }
            if (placesQuilombolasLayer.visible) {
                this.findAllGeometryShapeQuilombolasIntersects_ByCidade(cidadeInfo.id);
            }
            if (placesTerrasIndigenasLayer.visible) {
                this.findAllGeometryShapeTerrasIndigenasIntersects_ByCidade(cidadeInfo.id);
            }
            if (placesUsoSustentavelLayer.visible) {
                this.findAllGeometryShapeUsoSustentavelIntersects_ByCidade(cidadeInfo.id);
            }
            if (stateLayer.visible) {
                this.findGeometryAreaByEstado(cidadeInfo.estado.id, false);
            }


            let selectedCidades = [];
            selectedCidades.push(cidadeInfo);
            let selectedEstados = [];
            for (let e = 0; e < this.state.estados.length; e++) {
                if (this.state.estados[e].id === cidadeInfo.estado.id) {
                    selectedEstados.push(this.state.estados[e]);
                    break;
                }
            }

            this.setState({ selectedCidades, selectedEstados }, () => {
                this.findBySubs(false, true);
            });

            this.setState({ cidadeInfo });
        }
    }

    handleLoadingCanto() {
        if (loadingCanto) {
            document.getElementById("loadingIco").style.display = "block";
        } else {
            document.getElementById("loadingIco").style.display = "none";
        }
    }

    handleLoadingCentro() {
        if (loadingCentro) {
            document.getElementById("loadingIcoCenter").style.display = "block";
        } else {
            document.getElementById("loadingIcoCenter").style.display = "none";
        }
    }







    unirGeometries(layer = null, plotar = false, layerToPlotar = null, clearBefore = false, selecteds = []) {
        let list = [];
        loadModules([
            "esri/geometry/geometryEngine",
            "esri/Graphic"], options)
            .then(([geometryEngine, Graphic]) => {

                if (selecteds.length > 0) {
                    if (layer !== null && layer.graphics !== null && layer.graphics.items.length > 0) {
                        let clone = new Graphic(layer.graphics.items[0].geometry, creteSymbolOk);
                        let union = null;

                        for (let i = 0; i < layer.graphics.items.length; i++) {
                            list.push(layer.graphics.items[i].geometry);
                        }
                        union = geometryEngine.union(list);
                        list = [];
                        for (let i = 0; i < union.rings.length; i++) {
                            let g = new Graphic(clone.geometry.clone(), creteSymbolOk);
                            g.geometry.rings = union.rings[i];
                            list.push(g);
                        }
                        this.removeInsideGeometries(list, plotar, layerToPlotar, clearBefore, selecteds);
                    } else {

                        let clone = new Graphic(selecteds[0].geometry, creteSymbolOk);
                        let union = null;

                        for (let i = 0; i < selecteds.length; i++) {
                            list.push(selecteds[i].geometry);
                        }
                        union = geometryEngine.union(list);
                        list = [];
                        for (let i = 0; i < union.rings.length; i++) {
                            let g = new Graphic(clone.geometry.clone(), creteSymbolOk);
                            g.geometry.rings = union.rings[i];
                            list.push(g);
                        }
                        this.removeInsideGeometries(list, plotar, layerToPlotar, clearBefore, selecteds);
                    }
                } else {
                    this.show('danger', this.props.t('erros.erro_0055'));
                    this.show('danger', this.props.t('erros.erro_0056'), 8);
                }
            });
    }

    removeInsideGeometries(graphicList, plotar = false, layer = null, clearBefore = false, selecteds = []) {
        loadModules([
            "esri/geometry/geometryEngine"], options)
            .then(([geometryEngine]) => {

                if (graphicList.length > 0) {
                    let list = [];
                    let contains = false;
                    let existsContains = null;
                    let total = graphicList.length;
                    for (let i = 0; i < total; i++) {
                        existsContains = false;
                        for (let j = 0; j < total; j++) {
                            if (i !== j) {
                                contains = geometryEngine.contains(graphicList[j].geometry, graphicList[i].geometry);
                                if (contains) {
                                    existsContains = true;
                                    break;
                                }
                            }
                        }
                        if (!existsContains) {
                            list.push(graphicList[i]);
                        }
                    }
                    if (plotar) {
                        this.plotarGeometries(list, layer, clearBefore, selecteds);
                    } else {
                        this.cortarGeometries(list, layer, selecteds);
                    }
                }
            });
    }

    cortarGeometries(geometries, layer = null, selecteds = []) {
        loadModules([
            "esri/geometry/geometryEngine",
            "esri/geometry/SpatialReference",
            "esri/geometry/projection",
            "esri/geometry/Polygon",
            "esri/Graphic"], options)
            .then(([geometryEngine, SpatialReference, projection, Polygon, Graphic]) => {

                let intersects = null;
                // geologyLayer2.graphics.removeAll();
                for (let i = 0; i < selecteds.length; i++) {
                    let graphic = selecteds[i];
                    let geometry = projection.project(graphic.geometry, SpatialReference.WGS84);
                    for (let j = 0; j < geometries.length; j++) {
                        intersects = geometryEngine.intersects(geometry, geometries[j].geometry);
                        if (intersects) {
                            geometry = geometryEngine.difference(geometry, geometries[j].geometry);
                        }
                    }
                    geometry = projection.project(geometry, view.spatialReference);
                    layer.graphics.remove(graphic);

                    if (geometry.rings.length > 1) {
                        let contains = false;
                        let existsContains = null;
                        let total = geometry.rings.length;
                        for (let i = 0; i < total; i++) {
                            existsContains = false;

                            let polygon = new Polygon({
                                rings: defaultRings,
                                spatialReference: view.spatialReference
                            });
                            polygon.rings = geometry.rings[i];
                            let g = new Graphic(polygon, creteSymbolOk);

                            for (let j = 0; j < total; j++) {
                                if (i !== j) {
                                    let g2 = new Graphic(geometry.clone(), creteSymbolOk);
                                    g2.geometry.rings = geometry.rings[j];
                                    contains = geometryEngine.contains(g2.geometry, g.geometry);
                                    if (contains) {
                                        existsContains = true;
                                        break;
                                    }
                                }
                            }
                            if (!existsContains) {
                                g.attributes = {
                                    state: graphic.attributes.state,
                                    uid: graphic.attributes.uid + "-" + i,
                                    invalid: false,
                                    cutted: true
                                }
                                layer.graphics.add(g);
                            }
                        }
                    } else {
                        let g = new Graphic(geometry, creteSymbolOk);
                        g.attributes = {
                            state: graphic.attributes.state,
                            uid: graphic.attributes.uid,
                            invalid: false,
                            cutted: true
                        }
                        layer.graphics.add(g);
                    }
                }
            });
    }

    areaGeometries(selecteds, typeArea = null, htmlComponent = null, title = "") {
        if (selecteds.length > 0) {
            loadModules([
                "esri/geometry/geometryEngine",
                "esri/geometry/SpatialReference",
                "esri/geometry/projection",
                "esri/Graphic"], options)
                .then(([geometryEngine, SpatialReference, projection, Graphic]) => {

                    let total = 0;
                    let totalHc = 0;
                    let value = 0;
                    let valueHc = 0;
                    let type = "acres";
                    let typeName = "Ácres";

                    for (let i = 0; i < selecteds.length; i++) {
                        let graphic = selecteds[i];
                        let geometry = projection.project(graphic.geometry, SpatialReference.WGS84);
                        value = geometryEngine.geodesicArea(geometry, "acres");
                        total += value;

                        valueHc = geometryEngine.geodesicArea(geometry, "hectares");
                        totalHc += valueHc;
                    }

                    // if(typeArea !== null){
                    //   type = typeArea.value;
                    //   typeName = typeArea.label;
                    // }

                    // switch(type){
                    //   case "hectares":
                    //     total = total / 2.471;
                    //   break;
                    //   case "miles":
                    //     total = total / 661;
                    //   break;
                    //   case "kilometers":
                    //     total = total / 247;
                    //   break;
                    //   case "meters":
                    //     total = total / 4047;
                    // }

                    // if(htmlComponent !== null){
                    document.getElementById("requerimentoNameAreaLabelAcres").innerHTML = "Acres: " + total;
                    document.getElementById("requerimentoNameAreaLabelHc").innerHTML = "Hectares: " + totalHc;
                    // }

                    // acres: 12566.395249601239 => / 2,471 ==> 5085,4397322265631374 hectares
                    // acres: 12566.395249601239 => / 661 ==> 19,634992577501936495 miles
                    // acres: 12566.395249601239 => / 247 ==> 50,854397322265633363 kilometers
                    // acres: 12566.395249601239 => / 4047 ==> 50854397,322265632451 meters

                    // hectares: 5085.439732226563 => * 2,471 ==> 12566.395249601239 hectares
                    // hectares: 5085.439732226563 => / 259 ==> 19,634992577501936495 miles
                    // hectares: 5085.439732226563 => / 99,991 ==> 50,854397322265633363 kilometers
                    // hectares: 5085.439732226563 => / 10001 ==> 50854397,322265632451 meters
                });
        } else {
            this.show('danger', this.props.t('erros.erro_0055'));
            this.show('danger', this.props.t('erros.erro_0056'), 8);
        }
    }

    plotarGeometries(graphicList, layer = null, clearBefore = false, selecteds = []) {
        if (graphicList.length > 0) {
            if (clearBefore) {
                if (selecteds.length > 0) {
                    for (let i = 0; i < selecteds.length; i++) {
                        layer.graphics.remove(selecteds[i]);
                    }
                } else {
                    layer.graphics.removeAll();
                }
            }
            for (let i = 0; i < graphicList.length; i++) {
                layer.graphics.add(graphicList[i]);
            }
        }
    }




    cortarRequirementPolygons() {
        this.unirGeometries(requirementLayer, false, graphicsLayer, false, selectedGraphics);
    }

    unirRequirementPolygons() {
        this.unirGeometries(null, true, graphicsLayer, true, selectedGraphics);
    }

    areaRequirementPolygons(selecteds) {
        this.areaGeometries(selectedGraphics);
    }

    saveRequirementPolygons() {
        if (selectedGraphics.length > 0) {
            let graphics = [];
            let valid = true;
            for (let i = 0; i < selectedGraphics.length; i++) {
                if (selectedGraphics[i].geometry.type === "polygon") {
                    graphics.push(selectedGraphics[i]);
                }
                if (selectedGraphics[i].attributes.invalid) {
                    valid = false;
                    break;
                }
            }

            if (valid) {
                let requerimentoNameSave = '';
                if (graphics.length > 0) {
                    if (this.state.data.requerimentoNameSave === null || this.state.data.requerimentoNameSave === undefined || this.state.data.requerimentoNameSave.length <= 0) {
                        this.show('danger', this.props.t('erros.erro_0050'));
                    } else {
                        requerimentoNameSave = this.state.data.requerimentoNameSave;

                        loadModules([
                            "esri/geometry/geometryEngine",
                            "esri/geometry/SpatialReference",
                            "esri/geometry/projection",
                            "esri/Graphic",
                            "esri/geometry/Point",
                            "esri/geometry/coordinateFormatter"], options)
                            .then(([geometryEngine, SpatialReference, projection, Graphic, Point, coordinateFormatter]) => {

                                const { t } = this.props;

                                coordinateFormatter.load().then(function () {
                                    let listToSave = [];
                                    let dms = "";
                                    let intersects = false;
                                    let cidades = [];
                                    let acres = 0;
                                    let hectares = 0;

                                    for (let i = 0; i < graphics.length; i++) {
                                        let geometry = projection.project(graphics[i].geometry, SpatialReference.WGS84);
                                        let g = new Graphic(geometry, creteSymbolOk);

                                        dms = "";
                                        let rings = geometry.rings[0];
                                        for (let i = 0; i < rings.length; i++) {
                                            let point = new Point({
                                                longitude: rings[i][0],
                                                latitude: rings[i][1]
                                            });
                                            dms += coordinateFormatter.toLatitudeLongitude(point, "dms", 3) + ";";

                                            // point = new Point({
                                            //   longitude: rings[i][0],
                                            //   latitude: rings[i][1]
                                            // });
                                            // let wgs84Point = projection.project(point, SpatialReference.WGS84);
                                            // dms += coordinateFormatter.toLatitudeLongitude(wgs84Point, "dms", 3) + ";";
                                        }

                                        for (let r = 0; r < cityVizinhaLayer.graphics.items.length; r++) {
                                            intersects = geometryEngine.intersects(cityVizinhaLayer.graphics.items[r].geometry, geometry);
                                            if (intersects) {
                                                cidades.push(cityVizinhaLayer.graphics.items[r].attributes.cidade);
                                            }
                                        }

                                        acres = geometryEngine.geodesicArea(geometry, "acres");
                                        hectares = geometryEngine.geodesicArea(geometry, "hectares");

                                        listToSave.push({
                                            graphic: g,
                                            dms: dms,
                                            acres: acres,
                                            hectares: hectares
                                        });
                                    }

                                    let cidadeDivisa = cidadeInfo.estado.name + " - " + cidadeInfo.name + ";";
                                    for (let e = 0; e < cidades.length; e++) {
                                        cidadeDivisa += cidades[e].estado.name + " - " + cidades[e].name + ";";
                                    }

                                    db.save(requerimentoNameSave, cidadeDivisa, listToSave, 'REQUERIMENTO');

                                    expandRequerimento.collapse();

                                    fetch('https://www.google.com/', { mode: 'no-cors', })
                                        .then(() => {
                                            //CONNECTED TO INTERNET
                                            let request = {
                                                dataUserGeometryList: []
                                            };
                                            let bd = db.getDB();
                                            let requirements = bd.requirements;
                                            if (requirements.length > 0) {
                                                for (let index = 0; index < requirements.length; index++) {
                                                    request.dataUserGeometryList.push(requirements[index]);
                                                }
                                                saveRequirement(request)
                                                    .then(obj => {
                                                        if (obj !== null && obj !== undefined && obj.error === undefined) {
                                                            if (obj.erros === null || obj.erros === undefined || obj.erros.length === 0) {
                                                                bd.requirements = [];
                                                                db.update(bd);

                                                                notificationTC.notice({
                                                                    content: <FullWideNotification
                                                                        color={'success'}
                                                                        message={t('forms.dataCreateSuccessRequirement')}
                                                                    />,
                                                                    duration: 5,
                                                                    closable: true,
                                                                    style: { top: 0, left: 0 },
                                                                    className: `full ltr-support`,
                                                                });

                                                                notificationTC.notice({
                                                                    content: <FullWideNotification
                                                                        color={'success'}
                                                                        message={t('forms.dataCreateSuccessRequirementInfo')}
                                                                    />,
                                                                    duration: 15,
                                                                    closable: true,
                                                                    style: { top: 0, left: 0 },
                                                                    className: `full ltr-support`,
                                                                });

                                                            } else {
                                                                if (obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0) {
                                                                    for (let i = 0; i < obj.erros.length; i++) {
                                                                        notificationTC.notice({
                                                                            content: <FullWideNotification
                                                                                color={'danger'}
                                                                                message={t('erros.' + obj.erros[i])}
                                                                            />,
                                                                            duration: 10,
                                                                            closable: true,
                                                                            style: { top: 0, left: 0 },
                                                                            className: `full ltr-support`,
                                                                        });
                                                                    }
                                                                }
                                                            }
                                                        } else {
                                                            notificationTC.notice({
                                                                content: <FullWideNotification
                                                                    color={'danger'}
                                                                    message={t('forms.dataCreateError')}
                                                                />,
                                                                duration: 5,
                                                                closable: true,
                                                                style: { top: 0, left: 0 },
                                                                className: `full ltr-support`,
                                                            });
                                                        }
                                                    });
                                            }
                                        }).catch(() => {
                                            //INTERNET CONNECTIVITY ISSUE
                                            notificationTC.notice({
                                                content: <FullWideNotification
                                                    color={'danger'}
                                                    message={t('erros.erro_0058')}
                                                />,
                                                duration: 10,
                                                closable: true,
                                                style: { top: 0, left: 0 },
                                                className: `full ltr-support`,
                                            });
                                            notificationTC.notice({
                                                content: <FullWideNotification
                                                    color={'danger'}
                                                    message={t('erros.erro_0059')}
                                                />,
                                                duration: 15,
                                                closable: true,
                                                style: { top: 0, left: 0 },
                                                className: `full ltr-support`,
                                            });
                                        });
                                });
                            });
                    }
                } else {
                    this.show('danger', this.props.t('erros.erro_0054'));
                }
            } else {
                this.show('danger', this.props.t('erros.erro_0060'));
            }
        } else {
            this.show('danger', this.props.t('erros.erro_0055'));
            this.show('danger', this.props.t('erros.erro_0056'), 8);
        }
    }

    getAllRequirementsByUser() {
        findAllRequirementsByUser(user).then(response => {
            if (response === undefined) {
                response = [];
            }
            let options = [];
            if (response !== undefined && response.error === undefined) {
                if (response.dataUserGeometryList !== undefined && response.dataUserGeometryList !== null && response.dataUserGeometryList.length > 0 && this.state.allRequirements.length === 0) {
                    for (let i = 0; i < response.dataUserGeometryList.length; i++) {
                        options.push({ value: response.dataUserGeometryList[i].id, label: response.dataUserGeometryList[i].name });
                    }
                    this.setState({
                        allRequirements: response.dataUserGeometryList,
                        requirementsList: options,
                        selectedRequirements: []
                    }, () => {
                        if (buffer_OK) {
                            this.plotarRequerimentos(response, symbolsMap, false);

                            this.getAllBuffersByUser();
                        }
                    });
                } else {
                    this.setState({
                        allRequirements: [],
                        requirementsList: [],
                        selectedRequirements: []
                    }, () => {
                        if (buffer_OK) {
                            this.getAllBuffersByUser();
                        }
                    });
                }
            } else {
                if (response.errors === undefined) {
                    response = [];
                    this.show('danger', this.props.t('forms.errorListData'));
                } else {
                    response = [];
                    this.show('danger', response.errors[0].defaultMessage);
                }
                if (buffer_OK) {
                    this.getAllBuffersByUser();
                }
            }
        });
    }

    clearRequirements() {
        const data = { ...this.state.data }
        let selectedRequirements = [];
        let selectedRequirementsObj = [];
        data["requerimentoNameSave"] = "";
        for (let j = (graphicsLayer.graphics.items.length - 1); j >= 0; j--) {
            if (graphicsLayer.graphics.items[j].attributes !== null && graphicsLayer.graphics.items[j].attributes !== undefined &&
                graphicsLayer.graphics.items[j].attributes.type !== null && graphicsLayer.graphics.items[j].attributes.type !== undefined &&
                graphicsLayer.graphics.items[j].attributes.type === "REQUERIMENTO") {
                graphicsLayer.graphics.remove(graphicsLayer.graphics.items[j]);
            }
        }
        this.setState({ data, selectedRequirements, selectedRequirementsObj }, () => {
        });
    }

    updateRequirementsFieldSelect(event) {
        const data = { ...this.state.data }

        let selectedRequirements = [];
        let selectedRequirementsObj = [];
        data["requerimentoNameSave"] = "";

        if (event !== null && event.length > 0) {
            for (let j = (event.length - 1); j < event.length; j++) {
                for (let i = 0; i < this.state.allRequirements.length; i++) {
                    if (this.state.allRequirements[i].id === event[j].value) {
                        selectedRequirements.push(event[j]);
                        data["requerimentoNameSave"] = this.state.allRequirements[i].name;
                        this.plotarSavedGeometry(this.state.allRequirements[i], "REQUERIMENTO");
                        break;
                    }
                }
            }
        }
        this.setState({ data, selectedRequirements, selectedRequirementsObj }, () => {
        });
    }





    createBuffer(layer = null, selecteds = []) {
        if (selecteds.length > 0) {
            let graphics = [];
            for (let i = 0; i < selecteds.length; i++) {
                if (selecteds[i].geometry.type === "polyline" || selecteds[i].geometry.type === "point") {
                    graphics.push(selecteds[i]);
                }
            }

            if (graphics.length > 0) {
                if (bufferSize !== null && bufferSize !== undefined && bufferSize > 0) {
                    loadModules([
                        "esri/geometry/geometryEngine",
                        "esri/geometry/SpatialReference",
                        "esri/geometry/projection",
                        "esri/Graphic",
                        "esri/geometry/Polygon",
                        "esri/geometry/Circle"], options)
                        .then(([geometryEngine, SpatialReference, projection, Graphic, Polygon, Circle]) => {

                            let intersects = null;
                            let symbol = null;

                            let bufferedGraphic = null;
                            for (let i = 0; i < graphics.length; i++) {
                                if (graphics[i].attributes === null || graphics[i].attributes === undefined ||
                                    graphics[i].attributes.cutted === undefined || graphics[i].attributes.invalid === undefined) {
                                    this.show('danger', this.props.t('erros.erro_0055'));
                                    this.show('danger', this.props.t('erros.erro_0056'), 8);
                                } else {
                                    symbol = creteSymbol;
                                    if (graphics[i].geometry != null && graphics[i].geometry.type === "polyline") {
                                        if (graphics[i].geometry.paths != null) {
                                            let geometry = projection.project(graphics[i].geometry, SpatialReference.WGS84);
                                            let buffered = geometryEngine.geodesicBuffer(geometry, bufferSize, "meters");

                                            if (requirementLayer.graphics !== null && requirementLayer.graphics.items.length > 0) {
                                                for (let r = 0; r < requirementLayer.graphics.items.length; r++) {
                                                    intersects = geometryEngine.intersects(requirementLayer.graphics.items[r].geometry, buffered);
                                                    symbol = intersects ? invalidSymbol : creteSymbol;
                                                    if (intersects) {
                                                        break;
                                                    }
                                                }
                                            }
                                            buffered = projection.project(buffered, graphics[i].geometry.spatialReference);
                                            bufferedGraphic = new Graphic(buffered, symbol);
                                        }
                                    } else {
                                        let circle = new Circle({
                                            center: graphics[i].geometry,
                                            radius: bufferSize,
                                            radiusUnit: "meters",
                                        });
                                        let buffered = new Polygon({
                                            rings: defaultRings,
                                            spatialReference: graphics[i].geometry.spatialReference
                                        });
                                        buffered.rings = circle.rings;

                                        let geometry = projection.project(buffered, SpatialReference.WGS84);
                                        if (requirementLayer.graphics !== null && requirementLayer.graphics.items.length > 0) {
                                            for (let r = 0; r < requirementLayer.graphics.items.length; r++) {
                                                intersects = geometryEngine.intersects(requirementLayer.graphics.items[r].geometry, geometry);
                                                symbol = intersects ? invalidSymbol : creteSymbol;
                                                if (intersects) {
                                                    break;
                                                }
                                            }
                                        }
                                        bufferedGraphic = new Graphic(buffered, symbol);
                                    }
                                    bufferedGraphic.attributes = graphics[i].attributes;
                                    bufferedGraphic.attributes.cutted = true;
                                    bufferedGraphic.attributes.invalid = false;
                                    layer.graphics.add(bufferedGraphic);
                                    // layer.graphics.remove(graphics[i]);
                                }
                            }
                        });
                } else {
                    this.show('danger', this.props.t('erros.erro_0048'));
                }
            } else {
                this.show('danger', this.props.t('erros.erro_0053'));
            }
        } else {
            this.show('danger', this.props.t('erros.erro_0055'));
            this.show('danger', this.props.t('erros.erro_0056'), 8);
        }
    }

    createBufferPolygons() {
        this.createBuffer(graphicsLayer, selectedGraphics);
    }

    saveBufferPolygons() {
        if (selectedGraphics.length > 0) {
            let graphics = [];
            for (let i = 0; i < selectedGraphics.length; i++) {
                //if(selectedGraphics[i].geometry.type === "polygon"){
                graphics.push(selectedGraphics[i]);
                //}
            }

            if (graphics.length > 0) {
                let bufferNameSave = '';

                if (this.state.data.bufferNameSave === null || this.state.data.bufferNameSave === undefined || this.state.data.bufferNameSave.length <= 0) {
                    this.show('danger', this.props.t('erros.erro_0051'));
                } else {
                    bufferNameSave = this.state.data.bufferNameSave;

                    const { t } = this.props;

                    loadModules([
                        "esri/geometry/geometryEngine",
                        "esri/geometry/SpatialReference",
                        "esri/geometry/projection",
                        "esri/Graphic",
                        "esri/geometry/Point",
                        "esri/geometry/coordinateFormatter"], options)
                        .then(([geometryEngine, SpatialReference, projection, Graphic, Point, coordinateFormatter]) => {

                            coordinateFormatter.load().then(function () {
                                let listToSave = [];
                                let dms = "";
                                let intersects = false;
                                let cidades = [];
                                let acres = 0;
                                let hectares = 0;

                                for (let i = 0; i < graphics.length; i++) {
                                    let geometry = projection.project(graphics[i].geometry, SpatialReference.WGS84);
                                    let g = new Graphic(geometry, creteSymbolOk);

                                    dms = "";
                                    if (geometry.type === "polygon") {
                                        let rings = geometry.rings[0];
                                        for (let i = 0; i < rings.length; i++) {
                                            let point = new Point({
                                                longitude: rings[i][0],
                                                latitude: rings[i][1]
                                            });
                                            dms += coordinateFormatter.toLatitudeLongitude(point, "dms", 3) + ";";
                                        }
                                    } else if (geometry.type === "polyline") {
                                        let paths = geometry.paths[0];
                                        for (let i = 0; i < paths.length; i++) {
                                            let point = new Point({
                                                longitude: paths[i][0],
                                                latitude: paths[i][1]
                                            });
                                            dms += coordinateFormatter.toLatitudeLongitude(point, "dms", 3) + ";";
                                        }
                                    } else {
                                        let point = new Point({
                                            longitude: geometry.longitude,
                                            latitude: geometry.latitude
                                        });
                                        dms += coordinateFormatter.toLatitudeLongitude(point, "dms", 3) + ";";
                                    }

                                    for (let r = 0; r < cityVizinhaLayer.graphics.items.length; r++) {
                                        intersects = geometryEngine.intersects(cityVizinhaLayer.graphics.items[r].geometry, geometry);
                                        if (intersects) {
                                            cidades.push(cityVizinhaLayer.graphics.items[r].attributes.cidade);
                                        }
                                    }

                                    acres = geometryEngine.geodesicArea(geometry, "acres");
                                    hectares = geometryEngine.geodesicArea(geometry, "hectares");

                                    listToSave.push({
                                        graphic: g,
                                        dms: dms,
                                        acres: acres,
                                        hectares: hectares
                                    });
                                }

                                let cidadeDivisa = cidadeInfo.estado.name + " - " + cidadeInfo.name + ";";
                                for (let e = 0; e < cidades.length; e++) {
                                    cidadeDivisa += cidades[e].estado.name + " - " + cidades[e].name + ";";
                                }

                                db.save(bufferNameSave, cidadeDivisa, listToSave, 'BUFFER');

                                expandBuffer.collapse();

                                fetch('https://www.google.com/', { mode: 'no-cors', })
                                    .then(() => {
                                        //CONNECTED TO INTERNET
                                        let request = {
                                            dataUserGeometryList: []
                                        };
                                        let bd = db.getDB();
                                        let buffers = bd.buffers;
                                        if (buffers.length > 0) {
                                            for (let index = 0; index < buffers.length; index++) {
                                                request.dataUserGeometryList.push(buffers[index]);
                                            }
                                            saveBuffer(request)
                                                .then(obj => {
                                                    if (obj !== null && obj !== undefined && obj.error === undefined) {
                                                        if (obj.erros === null || obj.erros === undefined || obj.erros.length === 0) {
                                                            bd.buffers = [];
                                                            db.update(bd);

                                                            notificationTC.notice({
                                                                content: <FullWideNotification
                                                                    color={'success'}
                                                                    message={t('forms.dataCreateSuccessBuffer')}
                                                                />,
                                                                duration: 5,
                                                                closable: true,
                                                                style: { top: 0, left: 0 },
                                                                className: `full ltr-support`,
                                                            });

                                                            notificationTC.notice({
                                                                content: <FullWideNotification
                                                                    color={'success'}
                                                                    message={t('forms.dataCreateSuccessBufferInfo')}
                                                                />,
                                                                duration: 15,
                                                                closable: true,
                                                                style: { top: 0, left: 0 },
                                                                className: `full ltr-support`,
                                                            });

                                                        } else {
                                                            if (obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0) {
                                                                for (let i = 0; i < obj.erros.length; i++) {
                                                                    notificationTC.notice({
                                                                        content: <FullWideNotification
                                                                            color={'danger'}
                                                                            message={t('erros.' + obj.erros[i])}
                                                                        />,
                                                                        duration: 10,
                                                                        closable: true,
                                                                        style: { top: 0, left: 0 },
                                                                        className: `full ltr-support`,
                                                                    });
                                                                }
                                                            }
                                                        }
                                                    } else {
                                                        notificationTC.notice({
                                                            content: <FullWideNotification
                                                                color={'danger'}
                                                                message={t('forms.dataCreateError')}
                                                            />,
                                                            duration: 5,
                                                            closable: true,
                                                            style: { top: 0, left: 0 },
                                                            className: `full ltr-support`,
                                                        });
                                                    }
                                                });
                                        }
                                    }).catch(() => {
                                        //INTERNET CONNECTIVITY ISSUE
                                        notificationTC.notice({
                                            content: <FullWideNotification
                                                color={'danger'}
                                                message={t('erros.erro_0058')}
                                            />,
                                            duration: 10,
                                            closable: true,
                                            style: { top: 0, left: 0 },
                                            className: `full ltr-support`,
                                        });
                                        notificationTC.notice({
                                            content: <FullWideNotification
                                                color={'danger'}
                                                message={t('erros.erro_0062')}
                                            />,
                                            duration: 15,
                                            closable: true,
                                            style: { top: 0, left: 0 },
                                            className: `full ltr-support`,
                                        });
                                    });
                            });
                        });
                }
            } else {
                this.show('danger', this.props.t('erros.erro_0054'));
            }
        } else {
            this.show('danger', this.props.t('erros.erro_0055'));
            this.show('danger', this.props.t('erros.erro_0056'), 8);
        }
    }

    getAllBuffersByUser() {
        findAllBuffersByUser(user).then(response => {
            if (response === undefined) {
                response = [];
            }
            let options = [];
            if (response !== undefined && response.error === undefined) {
                if (response.dataUserGeometryList !== undefined && response.dataUserGeometryList !== null && response.dataUserGeometryList.length > 0 && this.state.allBuffers.length === 0) {
                    for (let i = 0; i < response.dataUserGeometryList.length; i++) {
                        options.push({ value: response.dataUserGeometryList[i].id, label: response.dataUserGeometryList[i].name });
                    }

                    this.setState({
                        allBuffers: response.dataUserGeometryList,
                        buffersList: options,
                        selectedBuffers: []
                    }, () => {
                    });
                } else {
                    this.setState({
                        allBuffers: [],
                        buffersList: [],
                        selectedBuffers: []
                    }, () => {
                    });
                }
            } else {
                if (response.errors === undefined) {
                    response = [];
                    this.show('danger', this.props.t('forms.errorListData'));
                } else {
                    response = [];
                    this.show('danger', response.errors[0].defaultMessage);
                }
            }
        });
    }

    clearBuffer() {
        const data = { ...this.state.data }
        let selectedBuffers = [];
        let selectedBuffersObj = [];
        data["bufferNameSave"] = "";
        for (let j = (graphicsLayer.graphics.items.length - 1); j >= 0; j--) {
            if (graphicsLayer.graphics.items[j].attributes !== null && graphicsLayer.graphics.items[j].attributes !== undefined &&
                graphicsLayer.graphics.items[j].attributes.type !== null && graphicsLayer.graphics.items[j].attributes.type !== undefined &&
                graphicsLayer.graphics.items[j].attributes.type === "BUFFER") {
                graphicsLayer.graphics.remove(graphicsLayer.graphics.items[j]);
            }
        }
        this.setState({ data, selectedBuffers, selectedBuffersObj }, () => {
        });
    }

    updateBufferFieldSelect(event) {
        const data = { ...this.state.data }

        let selectedBuffers = [];
        let selectedBuffersObj = [];
        data["bufferNameSave"] = "";

        if (event !== null && event.length > 0) {
            for (let j = (event.length - 1); j < event.length; j++) {
                for (let i = 0; i < this.state.allBuffers.length; i++) {
                    if (this.state.allBuffers[i].id === event[j].value) {
                        selectedBuffers.push(event[j]);
                        data["bufferNameSave"] = this.state.allBuffers[i].name;
                        this.plotarSavedGeometry(this.state.allBuffers[i], "BUFFER");
                        break;
                    }
                }
            }
        }
        this.setState({ data, selectedBuffers, selectedBuffersObj }, () => {
        });
    }

    plotarSavedGeometry(dataUserGeometryList, type) {
        loadingCentro = true;
        this.handleLoadingCentro();

        loadModules([
            "esri/geometry/geometryEngine",
            "esri/Graphic",
            "esri/geometry/Point",
            "esri/geometry/Polyline",
            "esri/geometry/Polygon",
            "esri/geometry/projection",
            "esri/geometry/SpatialReference",
            "esri/symbols/PictureMarkerSymbol"], options)
            .then(([geometryEngine, Graphic, Point, Polyline, Polygon, projection, SpatialReference, PictureMarkerSymbol]) => {

                let totalFeatures = dataUserGeometryList.geometryUser.length;
                let symbol = null;
                let geometry = null;
                let intersects = false;
                let intersectsApaIntegral = false;
                for (let i = 0; i < totalFeatures; i++) {
                    let geometries = dataUserGeometryList.geometryUser[i];
                    let coordinatesList = [];
                    symbol = creteSymbol;

                    if (geometries != null && geometries != undefined) {
                        if (geometries.coordinatesMultiList !== null && geometries.coordinatesMultiList !== undefined &&
                            geometries.coordinatesMultiList.length > 0) {
                            for (let m = 0; m < geometries.coordinatesMultiList.length; m++) {
                                coordinatesList.push(geometries.coordinatesMultiList[m]);
                            }
                        }
                        if (geometries.coordinatesList !== null && geometries.coordinatesList !== undefined &&
                            geometries.coordinatesList.length > 0) {
                            coordinatesList.push(geometries.coordinatesList);
                        }

                        if (coordinatesList.length > 0) {
                            for (let j = 0; j < coordinatesList.length; j++) {
                                let rings = [];
                                let coordinates = coordinatesList[j];
                                let total = coordinates.length;
                                for (let m = 0; m < total; m++) {
                                    let latlng = [];
                                    latlng.push(parseFloat(coordinates[m].lng));
                                    latlng.push(parseFloat(coordinates[m].lat));
                                    rings.push(latlng);
                                }
                                let polygon = new Polygon({
                                    rings: rings,
                                    spatialReference: SpatialReference.WGS84
                                });

                                if (requirementLayer.graphics !== null && requirementLayer.graphics.items.length > 0) {
                                    intersects = false;
                                    intersectsApaIntegral = false;
                                    for (let r = 0; r < requirementLayer.graphics.items.length; r++) {
                                        intersects = geometryEngine.intersects(requirementLayer.graphics.items[r].geometry, polygon);
                                        if (intersects) {
                                            break;
                                        }
                                    }
                                    if (!intersects && placesProtecaoIntegralLayer.graphics !== null && placesProtecaoIntegralLayer.graphics.items.length > 0) {
                                        for (let r = 0; r < placesProtecaoIntegralLayer.graphics.items.length; r++) {
                                            intersectsApaIntegral = geometryEngine.intersects(placesProtecaoIntegralLayer.graphics.items[r].geometry, polygon);
                                            if (intersectsApaIntegral) {
                                                break;
                                            }
                                        }
                                    }
                                    symbol = (intersects || intersectsApaIntegral) ? invalidSymbol : creteSymbol;
                                }

                                geometry = projection.project(polygon, view.spatialReference);

                                let g = new Graphic({
                                    geometry: geometry,
                                    symbol: symbol
                                });
                                g.attributes = {
                                    state: "complete",
                                    uid: g.uid,
                                    invalid: false,
                                    cutted: false,
                                    type: type
                                };

                                graphicsLayer.graphics.add(g);
                            }

                        } else if (geometries.pointLatLng !== null && geometries.pointLatLng !== undefined) {
                            let point = new Point({
                                longitude: parseFloat(geometries.pointLatLng.lng),
                                latitude: parseFloat(geometries.pointLatLng.lat),
                                spatialReference: SpatialReference.WGS84
                            });

                            geometry = projection.project(point, view.spatialReference);

                            let g = new Graphic(
                                geometry,
                                new PictureMarkerSymbol({
                                    url: pointImg,
                                    width: "15px",
                                    height: "15px"
                                })
                            );
                            g.attributes = {
                                state: "complete",
                                uid: g.uid,
                                invalid: false,
                                cutted: false,
                                type: type
                            };
                            graphicsLayer.graphics.add(g);

                        } else if (geometries.bboxList !== null && geometries.bboxList !== undefined &&
                            geometries.bboxList.length > 0) {
                            let paths = [];
                            let coordinates = geometries.bboxList;
                            let total = geometries.bboxList.length;
                            for (let m = 0; m < total; m++) {
                                let latlng = [];
                                latlng.push(parseFloat(coordinates[m].lng));
                                latlng.push(parseFloat(coordinates[m].lat));
                                paths.push(latlng);
                            }
                            let polyline = new Polyline({
                                paths: paths,
                                spatialReference: SpatialReference.WGS84
                            });

                            geometry = projection.project(polyline, view.spatialReference);

                            let g = new Graphic({
                                geometry: geometry,
                                symbol: symbol
                            });
                            g.attributes = {
                                state: "complete",
                                uid: g.uid,
                                invalid: false,
                                cutted: false,
                                type: type
                            };

                            graphicsLayer.graphics.add(g);
                        }
                    }
                }
                loadingCentro = false;
                this.handleLoadingCentro();
            });
    }


    

    createPolygon(coordinatesList, polygon) {
        for (let j = 0; j < coordinatesList.length; j++) {
            let rings = [];
            let coordinates = coordinatesList[j];
            let total = coordinates.length;
            for (let m = 0; m < total; m++) {
                let latlng = [];
                latlng.push(parseFloat(coordinates[m].lng));
                latlng.push(parseFloat(coordinates[m].lat));
                rings.push(latlng);
            }
            polygon.addRing(rings);
            console.log(polygon.isClockwise(rings));
        }                
        console.log(polygon.rings);
        return polygon;
    }


    //CidadeArea
    findGeometryAreaByCidade(cidadeId, callback, cidadeVizinha) {
        findAllGeometryAreaByCidade(cidadeId).then(response => {
            this.plotarGeometryAreaCidade(response, callback, true);
            if (cidadeVizinha) {
                this.findGeometryAreaByCidadeVizinha(cidadeInfo, false);
            }
        });
    }

    //CidadeAreaVizinha
    findGeometryAreaByCidadeVizinha(cidade, callback) {
        findAllGeometryAreaByCidadeVizinha(cidade).then(response => {
            this.plotarGeometryAreaCidade(response, callback, false);
        });
    }

    //EstadoArea
    findGeometryAreaByEstado(estadoId, callback) {
        findAllGeometryAreaByEstado(estadoId).then(response => {
            this.plotarGeometryAreaEstado(response, callback);
        });
    }

    plotarGeometryAreaCidade(response, callback = false, clearGeometries = true) {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Polygon",
            "esri/symbols/SimpleFillSymbol",], options)
            .then(([Graphic, Polygon, SimpleFillSymbol]) => {

                let totalFeatures = 0;
                if (response.geometryShapeCidadeAreaList !== null && response.geometryShapeCidadeAreaList !== undefined &&
                    response.geometryShapeCidadeAreaList.length > 0) {
                    totalFeatures = response.geometryShapeCidadeAreaList.length;
                }

                let symbol = null;
                let layer = cityLayer;
                if (clearGeometries) {
                    cityLayer.graphics.removeAll();
                    cityVizinhaLayer.graphics.removeAll();

                    symbol = new SimpleFillSymbol({
                        color: [135, 206, 250, 0.4],
                        outline: {
                            color: [0, 0, 0],
                            width: 1
                        }
                    });
                } else {
                    layer = cityVizinhaLayer;
                    symbol = new SimpleFillSymbol({
                        color: [255, 255, 255, 0.4],
                        outline: {
                            color: [255, 255, 255],
                            width: 2
                        }
                    });
                }

                let cidade = null;
                let coordinatesList = [];
                let geometry = null;
                for (let i = 0; i < totalFeatures; i++) {
                    coordinatesList = [];
                    geometry = response.geometryShapeCidadeAreaList[i];
                    cidade = geometry.cidade;

                    if (geometry.coordinatesMultiList !== null && geometry.coordinatesMultiList !== undefined &&
                        geometry.coordinatesMultiList.length > 0) {
                        coordinatesList = geometry.coordinatesMultiList;
                    }
                    if (geometry.coordinatesList !== null && geometry.coordinatesList !== undefined &&
                        geometry.coordinatesList.length > 0) {
                        coordinatesList.push(geometry.coordinatesList);
                    }

                    let polygon = new Polygon();
                    polygon = this.createPolygon(coordinatesList, polygon);

                    layer.graphics.add(new Graphic({
                        geometry: polygon,
                        symbol: symbol,
                        attributes: {
                            type: "Cidade",
                            obj: cidade
                        }
                    }));
                }
                if (callback && layer.graphics.items.length > 0) {
                    this.centerMapCity(layer.graphics.items[0].geometry);
                }
            });
    }

    plotarGeometryAreaEstado(response, callback = false) {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Polygon",
            "esri/symbols/SimpleFillSymbol",], options)
            .then(([Graphic, Polygon, SimpleFillSymbol]) => {

                let totalFeatures = 0;
                if (response.estadoList !== null && response.estadoList !== undefined && response.estadoList.length > 0) {
                    totalFeatures = response.estadoList.length;
                }
                stateLayer.graphics.removeAll();

                let symbol = new SimpleFillSymbol({
                    color: [198, 255, 200, 0.2],
                    outline: {
                        color: [0, 0, 0],
                        width: 1
                    }
                });

                let bbox = [];
                let estado = null;
                let geometryList = null;
                let totalGeometryList = [];
                for (let i = 0; i < totalFeatures; i++) {
                    estado = response.estadoList[i];
                    totalGeometryList = [];
                    geometryList = null;

                    if (estado.geometryEstadoAreaList != null && estado.geometryEstadoAreaList != undefined && estado.geometryEstadoAreaList.length > 0) {
                        totalGeometryList = estado.geometryEstadoAreaList.length;
                    }

                    if (totalGeometryList > 0) {
                        geometryList = estado.geometryEstadoAreaList;

                        for (let j = 0; j < totalGeometryList; j++) {
                            let geometry = geometryList[i];
                            let coordinatesList = [];
                            bbox = geometry.bboxList;

                            if (geometry.coordinatesMultiList !== null && geometry.coordinatesMultiList !== undefined &&
                                geometry.coordinatesMultiList.length > 0) {
                                coordinatesList = geometry.coordinatesMultiList;
                            }
                            if (geometry.coordinatesList !== null && geometry.coordinatesList !== undefined &&
                                geometry.coordinatesList.length > 0) {
                                coordinatesList.push(geometry.coordinatesList);
                            }
                            let polygon = new Polygon();
                            polygon = this.createPolygon(coordinatesList, polygon);
                            stateLayer.graphics.add(new Graphic({
                                geometry: polygon,
                                symbol: symbol,
                                attributes: {
                                    type: "Estado",
                                    obj: estado
                                }
                            }));
                        }
                    }
                }
                if (callback && stateLayer.graphics.items.length > 0) {
                    this.centerMapCity(stateLayer.graphics.items[0].geometry);
                }
            });
    }







    //Procurar Geologias
    findBySubs(callback = false, changeCity = false) {
        if (prefeiturasAdministradores || prefeituras) {
            if (this.state.selectedEstados.length === 0 || this.state.selectedCidades.length === 0) {
                this.show('danger', this.props.t('erros.erro_0047'));
                return;
            }
        }
        this.clearGeologyPolygons(changeCity, true);

        let request = {
            substancias: this.state.selectedSubstancias,
            estados: this.state.selectedEstados,
            cidades: this.state.selectedCidades
        }

        if (searchPanel_OK) {
            expandSearch.collapse();
        }

        searchGeometryShapes(request).then(response => {
            if (response === undefined || (response !== undefined && response.error === undefined)) {
                if (response.erros.length === 0) {
                    this.plotarGeologias(response, callback, changeCity);
                } else {
                    if (response.erros !== undefined && response.erros !== undefined && response.erros.length > 0) {
                        for (let i = 0; i < response.erros.length; i++) {
                            this.show('danger', this.props.t('erros.' + response.erros[i]));
                        }
                    }
                }
            } else {
                this.show('danger', this.props.t('forms.errorSearchingMap'));
            }
        });
    }

    clearGeologyPolygons(changeCity = false, search = false) {
        polygonList = [];
        polygonListIndex = -1;
        if (changeCity || totalGraphics === 0) {
            geologyLayer.graphics.removeAll();
            geologyLayer2.graphics.removeAll();
            polygonListMaxIndex = -1;
        } else {
            geologyLayer2.graphics.removeAll();
            for (let i = (geologyLayer.graphics.items.length - 1); i > (totalGraphics - 1); i--) {
                if (!geologyLayer.graphics.items[i].attributes.homeTown) {
                    geologyLayer.graphics.remove(geologyLayer.graphics.items[i]);
                }
            }
            for (let i = 0; i < geologyLayer.graphics.items.length; i++) {
                polygonList.push(geologyLayer.graphics.items[i].geometry);
            }
            if (polygonList.length > 0 && !search) {
                polygonListMaxIndex = polygonList.length - 1;
                this.focusBboxPoint(false, true);
            }
        }
    }

    //Geometrias sem cor no banco
    // findAllGeometryShapesByEstado_semCor(view, estadoId){
    //   findAllGeometryShapesByEstadoSemCor(estadoId).then(response =>{
    //     this.plotarGeologias(response, false, false);
    //   });
    // }

    plotarGeologias(response, callback = false, changeCity = false) {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Polygon",
            "esri/symbols/SimpleFillSymbol",], options)
            .then(([Graphic, Polygon, SimpleFillSymbol]) => {

                let totalFeatures = 0;
                if (response.geologiaList !== null && response.geologiaList !== undefined && response.geologiaList.length > 0) {
                    totalFeatures = response.geologiaList.length;
                }

                let geologia = {};
                let geometryList = null;
                let totalGeometryList = [];

                if (changeCity) {
                    polygonList = [];
                    polygonListIndex = -1;
                    polygonListMaxIndex = -1;
                    geologyLayer.graphics.removeAll();
                    geologyLayer2.graphics.removeAll();
                }

                for (let i = 0; i < totalFeatures; i++) {
                    totalGeometryList = [];
                    geometryList = null;

                    geologia = response.geologiaList[i];
                    if (geologia.geometryList != null && geologia.geometryList != undefined && geologia.geometryList.length > 0) {
                        totalGeometryList = geologia.geometryList.length;
                        geometryList = geologia.geometryList;
                    } else if (geologia.geometryEstadoList != null && geologia.geometryEstadoList != undefined && geologia.geometryEstadoList.length > 0) {
                        totalGeometryList = geologia.geometryEstadoList.length;
                        geometryList = geologia.geometryEstadoList;
                    }

                    if (totalGeometryList > 0) {
                        let symbol = null;
                        if (geologia.colorRGB !== null && geologia.colorRGB !== undefined && geologia.colorRGB.length > 0) {
                            let rgb = JSON.parse(geologia.colorRGB);
                            symbol = new SimpleFillSymbol({ // geologias
                                color: [rgb.r, rgb.g, rgb.b, .7], //rgb.a
                                outline: {
                                    color: [128, 128, 128], //0,0,0
                                    width: 0.5
                                }
                            });
                        } else {
                            symbol = new SimpleFillSymbol({
                                color: [160, 82, 45, .7],
                                outline: {
                                    color: [128, 128, 128],
                                    width: 0.5
                                }
                            });
                        }

                        for (let j = 0; j < totalGeometryList; j++) {
                            let geometry = geometryList[j];
                            let coordinatesList = [];

                            if (geometry.coordinatesMultiList !== null && geometry.coordinatesMultiList !== undefined &&
                                geometry.coordinatesMultiList.length > 0) {
                                coordinatesList = geometry.coordinatesMultiList;
                            }
                            if (geometry.coordinatesList !== null && geometry.coordinatesList !== undefined &&
                                geometry.coordinatesList.length > 0) {
                                coordinatesList.push(geometry.coordinatesList);
                            }

                            let polygon = new Polygon();
                            polygon = this.createPolygon(coordinatesList, polygon);
                            polygonList.push(polygon);

                            geologyLayer.graphics.add(
                                new Graphic({
                                    geometry: polygon,
                                    symbol: symbol,
                                    attributes: {
                                        type: "Geologia",
                                        simb1000: geologia.simb1000,
                                        nomeUNID: geologia.nomeUNID,
                                        subClasse1: geologia.subClasse1,
                                        lito1: geologia.lito1,
                                        lito2: geologia.lito2,
                                        clIdLITO: geologia.clIdLITO,
                                        description: geologia.description,
                                        homeTown: changeCity
                                    }
                                })
                            );
                        }
                    }
                }
                if (changeCity) {
                    totalGraphics = geologyLayer.graphics.items.length;
                } else {
                    polygonListIndex = polygonListMaxIndex;
                }
                if (polygonList.length > 0) {
                    polygonListMaxIndex = polygonList.length - 1;
                }
                this.focusBboxPoint(false, true, callback);
            });
    }




    searchProccessMap() {
        if (requirementLayer.graphics !== null && requirementLayer.graphics.items.length > 0) {
            loadModules([
                "esri/Graphic",
                "esri/geometry/Polyline"], options)
                .then(([Graphic, Polyline]) => {
                    requirementLayer2.graphics.removeAll();

                    let graphicRec = null;
                    for (let r = 0; r < requirementLayer.graphics.items.length; r++) {
                        if (requirementLayer.graphics.items[r].attributes.processo === searchProccessValue) {
                            graphicRec = requirementLayer.graphics.items[r];
                            break;
                        }
                    }

                    if (graphicRec !== null) {
                        requirementLayer2.graphics.add(
                            new Graphic({
                                geometry: new Polyline({
                                    paths: graphicRec.geometry.rings[0]
                                }),
                                symbol: symbolDestaque
                            })
                        );


                        let opts = {
                            duration: 3000
                        };

                        view.goTo({
                            target: graphicRec.geometry,
                            zoom: 13
                        }, opts).catch((error) => {
                            if (error.name != "AbortError") {
                                console.error(error);
                            }
                        });

                    } else if (searchProccessValue !== null && searchProccessValue !== undefined && searchProccessValue.length > 0) {
                        this.show('danger', this.props.t('erros.erro_0046'));
                    }
                });
        }
    }

    //Requerimentos 
    findAllGeometryShapeRequerimentosIntersects_ByCidade(cidadeId, symbolsMap, cidadeVizinha) {
        requirementLayer.graphics.removeAll();
        loadingCanto = true;
        this.handleLoadingCanto();
        findAllGeometryShapeRequerimentosIntersectsByCidade(cidadeId).then(response => {
            this.plotarRequerimentos(response, symbolsMap, false);
            if (cidadeVizinha) {
                this.findAllGeometryShapeRequerimentosIntersects_ByCidadeVizinhas(cidadeInfo, symbolsMap);
            }
        });
    }

    //Requerimentos Cidade Vizinha
    findAllGeometryShapeRequerimentosIntersects_ByCidadeVizinhas(cidade, symbolsMap) {
        loadingCentro = true;
        setTimeout(() => { this.handleLoadingCentro() }, 3000);
        findAllGeometryShapeRequerimentosIntersectsByCidadeVizinha(cidade).then(response => {
            this.plotarRequerimentos(response, symbolsMap, true);
        });
    }


    findAllGeometryShapesRequerimento_withoutCity(symbolsMap) {
        findAllGeometryShapesRequerimentoWithoutCity().then(response => {
            requirementLayer.graphics.removeAll();
            this.plotarRequerimentos(response, symbolsMap, false);
        });
    }


    plotarRequerimentos(response, symbolsMap, centro) {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Polygon",], options)
            .then(([Graphic, Polygon]) => {

                let totalFeatures = 0;
                if (response.geometryShapeRequerimentoList !== null && response.geometryShapeRequerimentoList !== undefined && response.geometryShapeRequerimentoList.length > 0) {
                    totalFeatures = response.geometryShapeRequerimentoList.length;
                }

                for (let i = 0; i < totalFeatures; i++) {
                    let geometries = response.geometryShapeRequerimentoList[i];
                    let requerimento = geometries.requerimento;
                    let coordinatesList = [];
                    if (geometries != null && geometries != undefined) {
                        if (geometries.coordinatesMultiList !== null && geometries.coordinatesMultiList !== undefined &&
                            geometries.coordinatesMultiList.length > 0) {
                            for (let m = 0; m < geometries.coordinatesMultiList.length; m++) {
                                coordinatesList.push(geometries.coordinatesMultiList[m]);
                            }
                        }
                        if (geometries.coordinatesList !== null && geometries.coordinatesList !== undefined &&
                            geometries.coordinatesList.length > 0) {
                            coordinatesList.push(geometries.coordinatesList);
                        }
                    }

                    let symbol = symbolsMap.get("4");//Dado Não Cadastrado
                    if (requerimento.fase !== null && requerimento.fase !== undefined
                        && requerimento.fase.code != null && requerimento.fase.code != undefined
                        && requerimento.fase.code.length > 0) {
                        symbol = symbolsMap.get(requerimento.fase.code);
                        if (requerimento.fase.code === "1" || requerimento.fase.code === "4") {
                            symbol = symbolsMap.get("6");
                        } else if (requerimento.fase.code === "5") {
                            symbol = symbolsMap.get("10");
                        }
                    }

                    let polygon = new Polygon();
                    polygon = this.createPolygon(coordinatesList, polygon);

                    // for (let j = 0; j < coordinatesList.length; j++) {
                    //     let polygon = new Polygon();
                    //     let rings = [];
                    //     let coordinates = coordinatesList[j];
                    //     let total = coordinates.length;
                    //     for (let m = 0; m < total; m++) {
                    //         let latlng = [];
                    //         latlng.push(parseFloat(coordinates[m].lng));
                    //         latlng.push(parseFloat(coordinates[m].lat));
                    //         rings.push(latlng);
                    //     }
                    //     polygon.addRing(rings);

                    requirementLayer.graphics.add(
                        new Graphic({
                            geometry: polygon,
                            symbol: symbol,
                            attributes: {
                                type: "Requerimento",
                                ano: requerimento.ano,
                                area_ha: requerimento.areaHA,
                                fase: requerimento.fase.name,
                                id: requerimento.idCode,
                                name: requerimento.name,
                                numero: requerimento.numero,
                                processo: requerimento.processo,
                                subs: requerimento.substancia.name,
                                uf: requerimento.uf,
                                ult_evento: requerimento.evento.name,
                                uso: requerimento.substanciaUso.name
                            }
                        })
                    );
                    // }
                }
                if (!centro) {
                    loadingCanto = false;
                    this.handleLoadingCanto();
                } else {
                    loadingCentro = false;
                    this.handleLoadingCentro();
                }
            });
    }







    //GeometryShapesCavernasService
    findAllGeometryShapeCavernasIntersects() {
        findAllGeometryShapeCavernas().then(response => {
            markersCavesLayer.graphics.removeAll();
            this.plotarPontos(response, false);
        });
    }
    findAllGeometryShapeCavernasIntersects_ByCidade(cidadeId) {
        findAllGeometryShapeCavernasIntersectsByCidade(cidadeId).then(response => {
            markersCavesLayer.graphics.removeAll();
            this.plotarPontos(response, false);
        });
    }

    //GeometryShapesSitiosArqueologicosService
    findAllGeometryShapeSitiosArqueologicosIntersects() {
        findAllGeometryShapeSitiosArqueologicos().then(response => {
            markersSitiosLayer.graphics.removeAll();
            this.plotarPontos(response, false);
        });
    }
    findAllGeometryShapeSitiosArqueologicosIntersects_ByCidade(cidadeId) {
        findAllGeometryShapeSitiosArqueologicosIntersectsByCidade(cidadeId).then(response => {
            markersSitiosLayer.graphics.removeAll();
            this.plotarPontos(response, false);
        });
    }

    plotarPontos(response, callback = false) {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Point",
            "esri/symbols/PictureMarkerSymbol"], options)
            .then(([Graphic, Point, PictureMarkerSymbol]) => {

                let type = "";
                let totalFeatures = 0;
                let markersLayer = null;

                if (response.cavernasList != null && response.cavernasList.length > 0) {
                    type = "cavernas";
                    totalFeatures = response.cavernasList.length;
                    markersLayer = markersCavesLayer;
                } else if (response.sitiosArqueologicosList != null && response.sitiosArqueologicosList.length > 0) {
                    type = "sitiosArqueologicos";
                    totalFeatures = response.sitiosArqueologicosList.length;
                    markersLayer = markersSitiosLayer;
                }

                let geologia = {};
                let pointLatLng = null;
                let firstPoint = null;
                for (let i = 0; i < totalFeatures; i++) {
                    let attributesPoligon = {};
                    let symbol = null;
                    pointLatLng = null;

                    if (type === "cavernas") {
                        geologia = response.cavernasList[i];
                        if (geologia.pointLatLng != null && geologia.pointLatLng != undefined) {
                            pointLatLng = geologia.pointLatLng;

                            attributesPoligon = {
                                type: "cavernas",
                                code: geologia.code,
                                codeExterno: geologia.codeExterno,
                                name: geologia.name,
                                cidade: geologia.cidade,
                                estado: geologia.estado,
                                localidade: geologia.localidade,
                                litologia: geologia.litologia,
                                classificacao: geologia.classificacao,
                                data: geologia.data,
                                validacao: geologia.validacao,
                                bibliografia: geologia.bibliografia
                            };

                            symbol = new PictureMarkerSymbol({
                                url: cavernaImg,
                                width: "15px",
                                height: "10px"
                            });
                        }
                    } else if (type === "sitiosArqueologicos") {
                        geologia = response.sitiosArqueologicosList[i];
                        if (geologia.pointLatLng != null && geologia.pointLatLng != undefined) {
                            pointLatLng = geologia.pointLatLng;

                            attributesPoligon = {
                                type: "sitiosArqueologicos",
                                code: geologia.code,
                                name: geologia.name,
                                cidade: geologia.cidade,
                                estado: geologia.estado,
                                instituicao: geologia.instituicao,
                                responsavel: geologia.responsavel,
                                area: geologia.area
                            };

                            symbol = new PictureMarkerSymbol({
                                url: sitiosImg,
                                width: "15px",
                                height: "15px"
                            });
                        }
                    }

                    if (pointLatLng !== null) {
                        let point = new Point({
                            longitude: parseFloat(pointLatLng.lng),
                            latitude: parseFloat(pointLatLng.lat)
                        });
                        if (firstPoint == null) {
                            firstPoint = point;
                        }

                        markersLayer.graphics.add(
                            new Graphic({
                                geometry: point,
                                symbol: symbol,
                                attributes: attributesPoligon
                            })
                        );
                    }
                }
                if (callback) {
                    this.centerMapCity(firstPoint);
                }
            });
    }





    //GeometryShapesProtecaoIntegralService
    findAllGeometryShapeProtecaoIntegralIntersects() {
        findAllGeometryShapeProtecaoIntegral().then(response => {
            placesProtecaoIntegralLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }
    findAllGeometryShapeProtecaoIntegralIntersects_ByCidade(cidadeId) {
        findAllGeometryShapeProtecaoIntegralIntersectsByCidade(cidadeId).then(response => {
            placesProtecaoIntegralLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }

    //GeometryShapesQuilombolasService
    findAllGeometryShapeQuilombolasIntersects() {
        findAllGeometryShapeQuilombolas().then(response => {
            placesQuilombolasLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }
    findAllGeometryShapeQuilombolasIntersects_ByCidade(cidadeId) {
        findAllGeometryShapeQuilombolasIntersectsByCidade(cidadeId).then(response => {
            placesQuilombolasLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }

    //GeometryShapesTerrasIndigenasService
    findAllGeometryShapeTerrasIndigenasIntersects() {
        findAllGeometryShapeTerrasIndigenas().then(response => {
            placesTerrasIndigenasLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }
    findAllGeometryShapeTerrasIndigenasIntersects_ByCidade(cidadeId) {
        findAllGeometryShapeTerrasIndigenasIntersectsByCidade(cidadeId).then(response => {
            placesTerrasIndigenasLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }

    //GeometryShapesUsoSustentavelService
    findAllGeometryShapeUsoSustentavelIntersects() {
        findAllGeometryShapeUsoSustentavel().then(response => {
            placesUsoSustentavelLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }
    findAllGeometryShapeUsoSustentavelIntersects_ByCidade(cidadeId) {
        findAllGeometryShapeUsoSustentavelIntersectsByCidade(cidadeId).then(response => {
            placesUsoSustentavelLayer.graphics.removeAll();
            this.plotarPoligonos(response, false);
        });
    }

    plotarPoligonos(response, callback = false) {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Polygon",
            "esri/symbols/SimpleFillSymbol",], options)
            .then(([Graphic, Polygon, SimpleFillSymbol]) => {

                let type = "";
                let totalFeatures = 0;
                let placesLayer = null;

                if (response.protecaoIntegralList != null && response.protecaoIntegralList.length > 0) {
                    type = "protecaoIntegral";
                    totalFeatures = response.protecaoIntegralList.length;
                    placesLayer = placesProtecaoIntegralLayer;
                } else if (response.quilombolasList != null && response.quilombolasList.length > 0) {
                    type = "quilombolas";
                    totalFeatures = response.quilombolasList.length;
                    placesLayer = placesQuilombolasLayer;
                } else if (response.terrasIndigenasList != null && response.terrasIndigenasList.length > 0) {
                    type = "terrasIndigenas";
                    totalFeatures = response.terrasIndigenasList.length;
                    placesLayer = placesTerrasIndigenasLayer;
                } else if (response.usoSustentavelList != null && response.usoSustentavelList.length > 0) {
                    type = "usoSustentavel";
                    totalFeatures = response.usoSustentavelList.length;
                    placesLayer = placesUsoSustentavelLayer;
                }

                let geologia = {};
                let geometryList = [];
                let totalGeometryList = [];
                let bbox = [];
                for (let i = 0; i < totalFeatures; i++) {
                    totalGeometryList = [];
                    geometryList = null;
                    let attributesPoligon = {};
                    let symbol = null;

                    if (type === "protecaoIntegral") {
                        geologia = response.protecaoIntegralList[i];
                        if (geologia.geometryShapeProtecaoIntegral != null && geologia.geometryShapeProtecaoIntegral != undefined && geologia.geometryShapeProtecaoIntegral.length > 0) {
                            totalGeometryList = geologia.geometryShapeProtecaoIntegral.length;
                            geometryList = geologia.geometryShapeProtecaoIntegral;

                            attributesPoligon = {
                                type: "protecaoIntegral",
                                name: geologia.name,
                                nameAbreviado: geologia.nameAbreviado,
                                sigla: geologia.sigla,
                                tipoUnidade: geologia.tipoUnidade,
                                info: geologia.info,
                                atoLegal: geologia.atoLegal,
                                anoCriacao: geologia.anoCriacao,
                                administracao: geologia.administracao,
                                area: geologia.area,
                                acres: geologia.acres,
                                hectares: geologia.hectares,
                                perimetro: geologia.perimetro
                            };

                            symbol = new SimpleFillSymbol({
                                color: [0, 128, 0, .6], //verde
                                outline: {
                                    color: [128, 128, 128],
                                    width: 0.5
                                }
                            });
                        }
                    } else if (type === "quilombolas") {
                        geologia = response.quilombolasList[i];
                        if (geologia.geometryShapeQuilombolas != null && geologia.geometryShapeQuilombolas != undefined && geologia.geometryShapeQuilombolas.length > 0) {
                            totalGeometryList = geologia.geometryShapeQuilombolas.length;
                            geometryList = geologia.geometryShapeQuilombolas;

                            attributesPoligon = {
                                type: "quilombolas",
                                name: geologia.name,
                                code: geologia.code,
                                processo: geologia.processo,
                                cidade: geologia.cidade,
                                estado: geologia.estado,
                                comunidade: geologia.comunidade,
                                dataPublicacao: geologia.dataPublicacao,
                                dataTitulo: geologia.dataTitulo,
                                area: geologia.area,
                                perimetro: geologia.perimetro
                            };

                            symbol = new SimpleFillSymbol({
                                color: [255, 255, 0, .6], // amarelo
                                outline: {
                                    color: [128, 128, 128],
                                    width: 0.5
                                }
                            });
                        }
                    } else if (type === "terrasIndigenas") {
                        geologia = response.terrasIndigenasList[i];
                        if (geologia.geometryShapeTerrasIndigenas != null && geologia.geometryShapeTerrasIndigenas != undefined && geologia.geometryShapeTerrasIndigenas.length > 0) {
                            totalGeometryList = geologia.geometryShapeTerrasIndigenas.length;
                            geometryList = geologia.geometryShapeTerrasIndigenas;

                            attributesPoligon = {
                                type: "terrasIndigenas",
                                name: geologia.name,
                                nameAbreviado: geologia.nameAbreviado,
                                nameTi: geologia.nameTi,
                                dataSituacao: geologia.dataSituacao,
                                grupoEtnico: geologia.grupoEtnico,
                                situacaoJu: geologia.situacaoJu
                            };

                            symbol = new SimpleFillSymbol({
                                color: [139, 0, 0, .6], //vermelho
                                outline: {
                                    color: [128, 128, 128],
                                    width: 0.5
                                }
                            });
                        }
                    } else if (type === "usoSustentavel") {
                        geologia = response.usoSustentavelList[i];
                        if (geologia.geometryShapeUsoSustentavel != null && geologia.geometryShapeUsoSustentavel != undefined && geologia.geometryShapeUsoSustentavel.length > 0) {
                            totalGeometryList = geologia.geometryShapeUsoSustentavel.length;
                            geometryList = geologia.geometryShapeUsoSustentavel;

                            attributesPoligon = {
                                type: "usoSustentavel",
                                name: geologia.name,
                                nameAbreviado: geologia.nameAbreviado,
                                sigla: geologia.sigla,
                                tipoUnidade: geologia.tipoUnidade,
                                info: geologia.info,
                                atoLegal: geologia.atoLegal,
                                anoCriacao: geologia.anoCriacao,
                                administracao: geologia.administracao,
                                area: geologia.area,
                                acres: geologia.acres,
                                hectares: geologia.hectares,
                                perimetro: geologia.perimetro
                            };

                            symbol = new SimpleFillSymbol({
                                color: [144, 238, 144, .6], //verde claro
                                outline: {
                                    color: [128, 128, 128],
                                    width: 0.5
                                }
                            });
                        }
                    }


                    if (totalGeometryList > 0) {
                        if (geologia.colorRGB !== null && geologia.colorRGB !== undefined && geologia.colorRGB.length > 0) {
                            let rgb = JSON.parse(geologia.colorRGB);
                            symbol = new SimpleFillSymbol({ // geologias
                                color: [rgb.r, rgb.g, rgb.b, 1], //rgb.a
                                outline: {
                                    color: [128, 128, 128], //0,0,0
                                    width: 0.5
                                }
                            });
                        }

                        for (let j = 0; j < totalGeometryList; j++) {
                            let geometry = geometryList[j];
                            let coordinatesList = [];
                            bbox = geometry.bboxList;

                            if (geometry.coordinatesMultiList !== null && geometry.coordinatesMultiList !== undefined &&
                                geometry.coordinatesMultiList.length > 0) {
                                coordinatesList = geometry.coordinatesMultiList;
                            }
                            if (geometry.coordinatesList !== null && geometry.coordinatesList !== undefined &&
                                geometry.coordinatesList.length > 0) {
                                coordinatesList.push(geometry.coordinatesList);
                            }
                            
                            let polygon = new Polygon();
                            polygon = this.createPolygon(coordinatesList, polygon);

                            placesLayer.graphics.add(
                                new Graphic({
                                    geometry: polygon,
                                    symbol: symbol,
                                    attributes: attributesPoligon
                                })
                            );
                        }
                    }
                }
                if (callback && placesLayer.graphics.items.length > 0) {
                    // this.centerMapCity(fisrtPolygon);
                    this.centerMapCity(placesLayer.graphics.items[0].geometry);
                }
            });
    }










    //Ação da tela
    searchGeologies() {
        this.findBySubs(true, false);
    }

    updateField(event) {
        const data = { ...this.state.data }

        data[event.target.name] = event.target.value;

        this.setState({ data });
    }

    updateFieldDMS(event) {
        const data = { ...this.state.data }

        let value = event.target.value;
        let name = event.target.name;

        let selectedLong = this.state.selectedLong;
        let selectedLat = this.state.selectedLat;

        //          10        20
        //01 34 6789012 456 89 1234567
        //12 52 40.829S 038 22 21.283W = 28
        if (name !== null && value !== null) {
            if (name === "dmsValueG_long") {
                let dms = value.split(" ");
                let total = (dms.length - 1);
                if (total > 0) { //"038 22 21.283W" = 14
                    let we = 'W';
                    let ns = 'S';
                    let dms2 = '';
                    let dms5 = '';

                    if (total === 2) {
                        data["dmsValueG_long"] = dms[0];
                        dmsValueG_long = dms[0];
                        data["dmsValueM_long"] = dms[1];
                        dmsValueM_long = dms[1];

                        if (dms[2][dms[2].length - 1] === 'E' || dms[2][dms[2].length - 1] === 'W') {
                            we = dms[2][dms[2].length - 1];
                            dms5 = dms[2].substring(0, (dms[2].length - 1));
                            selectedLong = (we === "W" ? this.state.longList[1] : this.state.longList[0]);
                            data["dmsValueS_long"] = dms5;
                            dmsValueS_long = dms5;
                            data["dmsValueZ_long"] = we;
                            dmsValueZ_long = we;
                        }
                    } else {
                        data["dmsValueG_lat"] = dms[0];
                        dmsValueG_lat = dms[0];
                        data["dmsValueM_lat"] = dms[1];
                        dmsValueM_lat = dms[1];

                        if (total >= 2) {
                            if (dms[2][dms[2].length - 1] === 'S' || dms[2][dms[2].length - 1] === 'N') {
                                ns = dms[2][dms[2].length - 1];
                                dms2 = dms[2].substring(0, (dms[2].length - 1));
                                selectedLat = (ns === "N" ? this.state.latList[1] : this.state.latList[0]);
                                data["dmsValueS_lat"] = dms2;
                                dmsValueS_lat = dms2;
                                data["dmsValueZ_lat"] = ns;
                                dmsValueZ_lat = ns;
                            }
                        }
                        if (total >= 3) { data["dmsValueG_long"] = dms[3]; dmsValueG_long = dms[3]; }
                        if (total >= 4) { data["dmsValueM_long"] = dms[4]; dmsValueM_long = dms[4]; }
                        if (total >= 5) {
                            if (dms[5][dms[5].length - 1] === 'E' || dms[5][dms[5].length - 1] === 'W') {
                                we = dms[5][dms[5].length - 1];
                                dms5 = dms[5].substring(0, (dms[5].length - 1));
                                selectedLong = (we === "W" ? this.state.longList[1] : this.state.longList[0]);
                                data["dmsValueS_long"] = dms5;
                                dmsValueS_long = dms5;
                                data["dmsValueZ_long"] = we;
                                dmsValueZ_long = we;
                            }
                        }
                    }
                } else {
                    if (event.target.name === "dmsValueG_long") {
                        dmsValueG_long = event.target.value;
                    } else if (event.target.name === "dmsValueM_long") {
                        dmsValueM_long = event.target.value;
                    } else if (event.target.name === "dmsValueS_long") {
                        dmsValueS_long = event.target.value;
                    } else if (event.target.name === "dmsValueG_lat") {
                        dmsValueG_lat = event.target.value;
                    } else if (event.target.name === "dmsValueM_lat") {
                        dmsValueM_lat = event.target.value;
                    } else if (event.target.name === "dmsValueS_lat") {
                        dmsValueS_lat = event.target.value;
                    }
                    data[event.target.name] = event.target.value;
                }
            } else if (name === "dmsValueG_lat") { //"12 52 40.829S" = 13
                let dms = value.split(" ");
                let total = (dms.length - 1);
                if (total > 0) { //"038 22 21.283W" = 14
                    let we = 'W';
                    let ns = 'S';
                    let dms2 = '';
                    let dms5 = '';

                    data["dmsValueG_lat"] = dms[0];
                    dmsValueG_lat = dms[0];
                    data["dmsValueM_lat"] = dms[1];
                    dmsValueM_lat = dms[1];

                    if (total >= 2) {
                        if (dms[2][dms[2].length - 1] === 'S' || dms[2][dms[2].length - 1] === 'N') {
                            ns = dms[2][dms[2].length - 1];
                            dms2 = dms[2].substring(0, (dms[2].length - 1));
                            selectedLat = (ns === "N" ? this.state.latList[1] : this.state.latList[0]);
                            data["dmsValueS_lat"] = dms2;
                            dmsValueS_lat = dms2;
                            data["dmsValueZ_lat"] = ns;
                            dmsValueZ_lat = ns;
                        }
                    }
                    if (total >= 3) { data["dmsValueG_long"] = dms[3]; dmsValueG_long = dms[3]; }
                    if (total >= 4) { data["dmsValueM_long"] = dms[4]; dmsValueM_long = dms[4]; }
                    if (total >= 5) {
                        if (dms[5][dms[5].length - 1] === 'E' || dms[5][dms[5].length - 1] === 'W') {
                            we = dms[5][dms[5].length - 1];
                            dms5 = dms[5].substring(0, (dms[5].length - 1));
                            selectedLong = (we === "W" ? this.state.longList[1] : this.state.longList[0]);
                            data["dmsValueS_long"] = dms5;
                            dmsValueS_long = dms5;
                            data["dmsValueZ_long"] = we;
                            dmsValueZ_long = we;
                        }
                    }
                } else {
                    if (event.target.name === "dmsValueG_long") {
                        dmsValueG_long = event.target.value;
                    } else if (event.target.name === "dmsValueM_long") {
                        dmsValueM_long = event.target.value;
                    } else if (event.target.name === "dmsValueS_long") {
                        dmsValueS_long = event.target.value;
                    } else if (event.target.name === "dmsValueG_lat") {
                        dmsValueG_lat = event.target.value;
                    } else if (event.target.name === "dmsValueM_lat") {
                        dmsValueM_lat = event.target.value;
                    } else if (event.target.name === "dmsValueS_lat") {
                        dmsValueS_lat = event.target.value;
                    }
                    data[event.target.name] = event.target.value;
                }
            } else {
                if (event.target.name === "dmsValueG_long") {
                    dmsValueG_long = event.target.value;
                } else if (event.target.name === "dmsValueM_long") {
                    dmsValueM_long = event.target.value;
                } else if (event.target.name === "dmsValueS_long") {
                    dmsValueS_long = event.target.value;
                } else if (event.target.name === "dmsValueG_lat") {
                    dmsValueG_lat = event.target.value;
                } else if (event.target.name === "dmsValueM_lat") {
                    dmsValueM_lat = event.target.value;
                } else if (event.target.name === "dmsValueS_lat") {
                    dmsValueS_lat = event.target.value;
                }
                data[event.target.name] = event.target.value;
            }
        }

        this.setState({ data, selectedLat, selectedLong });
    }

    updateProccessValue(event) {
        const data = { ...this.state.data }

        searchProccessValue = event.target.value;
        data[event.target.name] = searchProccessValue;
        this.setState({ data });
    }

    updateBufferField(event) {
        const data = { ...this.state.data }

        if (event.target.value === null || event.target.value === undefined || event.target.value <= 0) {
            this.show('danger', this.props.t('erros.erro_0048'));
            data[event.target.name] = event.target.value;
            bufferSize = 0;
        } else {
            bufferSize = parseFloat(event.target.value);
            data[event.target.name] = bufferSize;
        }
        this.setState({ data });
    }

    changeCity() {
        if (this.state.selectedEstados.length > 0 && this.state.selectedCidades.length > 0) {
            cidadeInfo = this.state.selectedCidades[0];
            this.configMap();
            expandChangeCity.collapse();
        } else {
            this.show('danger', this.props.t('erros.erro_0047'));
        }
    }

    updateSubsFieldSelect(event) {
        let selectedSubs = [];
        let selectedSubstancias = [];

        if (event !== null) {
            for (let j = 0; j < event.length; j++) {
                for (let i = 0; i < this.state.subsList.length; i++) {
                    if (this.state.subsList[i].value === event[j].value) {
                        selectedSubs.push(event[j]);

                        for (let s = 0; s < this.state.substancias.length; s++) {
                            if (this.state.substancias[s].id === event[j].value) {
                                selectedSubstancias.push(this.state.substancias[s]);
                                break;
                            }
                        }
                        break;
                    }
                }
            }
        }
        this.setState({ selectedSubs, selectedSubstancias }, () => {
        });
    }

    updateStatesFieldSelect(event) {
        let stateId = 0;
        if (event !== null && event.length > 0) {
            for (let j = (event.length - 1); j < event.length; j++) {
                stateId = event[j].value;
                this.setEstado({ id: stateId }, null);
            }
        } else {
            this.setEstado(null, null);
        }
        localStorage.setItem(environment.STATE_FILTER, stateId);
    }

    updateCitiesFieldSelect(event) {
        let cityId = 0;
        if (event !== null && event.length > 0) {
            for (let j = (event.length - 1); j < event.length; j++) {
                cityId = event[j].value;
                this.setCidade({ id: cityId }, false);
            }
        } else {
            this.setCidade(null, false);
        }
        localStorage.setItem(environment.CITY_FILTER, cityId);
    }

    updateLongSelect(event) {
        if (event !== null) {
            let selectedLong = [];
            selectedLong.push(event);
            dmsValueZ_long = selectedLong[0].value;
            this.setState({ selectedLong }, () => {
            });
        }
    }

    updateLatSelect(event) {
        if (event !== null) {
            let selectedLat = [];
            selectedLat.push(event);
            dmsValueZ_lat = selectedLat[0].value;
            this.setState({ selectedLat }, () => {
            });
        }
    }

    updateCheckbox(field) {
        const data = { ...this.state.data }
        data[field] = !data[field];

        if (field === "popupInfoView") {
            popupInfoView_OK = data[field];
        } else if (field === "cavernasView") {
            markersCavesLayer.visible = data[field];
            if (cidadeInfo !== null && cidadeInfo.id > 0 &&
                markersCavesLayer.visible && markersCavesLayer.graphics !== null && markersCavesLayer.graphics.items.length === 0) {
                this.findAllGeometryShapeCavernasIntersects_ByCidade(cidadeInfo.id);
            }
        } else if (field === "sitiosArqueologicosView") {
            markersSitiosLayer.visible = data[field];
            if (cidadeInfo !== null && cidadeInfo.id > 0 &&
                markersSitiosLayer.visible && markersSitiosLayer.graphics !== null && markersSitiosLayer.graphics.items.length === 0) {
                this.findAllGeometryShapeSitiosArqueologicosIntersects_ByCidade(cidadeInfo.id);
            }
        } else if (field === "protecaoIntegralView") {
            placesProtecaoIntegralLayer.visible = data[field];
            if (cidadeInfo !== null && cidadeInfo.id > 0 &&
                placesProtecaoIntegralLayer.visible && placesProtecaoIntegralLayer.graphics !== null && placesProtecaoIntegralLayer.graphics.items.length === 0) {
                this.findAllGeometryShapeProtecaoIntegralIntersects_ByCidade(cidadeInfo.id);
            }
        } else if (field === "quilombolasView") {
            placesQuilombolasLayer.visible = data[field];
            if (cidadeInfo !== null && cidadeInfo.id > 0 &&
                placesQuilombolasLayer.visible && placesQuilombolasLayer.graphics !== null && placesQuilombolasLayer.graphics.items.length === 0) {
                this.findAllGeometryShapeQuilombolasIntersects_ByCidade(cidadeInfo.id);
            }
        } else if (field === "terrasIndigenasView") {
            placesTerrasIndigenasLayer.visible = data[field];
            if (cidadeInfo !== null && cidadeInfo.id > 0 &&
                placesTerrasIndigenasLayer.visible && placesTerrasIndigenasLayer.graphics !== null && placesTerrasIndigenasLayer.graphics.items.length === 0) {
                this.findAllGeometryShapeTerrasIndigenasIntersects_ByCidade(cidadeInfo.id);
            }
        } else if (field === "usoSustentavalView") {
            placesUsoSustentavelLayer.visible = data[field];
            if (cidadeInfo !== null && cidadeInfo.id > 0 &&
                placesUsoSustentavelLayer.visible && placesUsoSustentavelLayer.graphics !== null && placesUsoSustentavelLayer.graphics.items.length === 0) {
                this.findAllGeometryShapeUsoSustentavelIntersects_ByCidade(cidadeInfo.id);
            }
        } else if (field === "requerimentoView") {
            requirementLayer.visible = data[field];
        } else if (field === "geologiaView") {
            geologyLayer.visible = data[field];
        } else if (field === "geologiaBordaView") {
            geologyLayer2.visible = data[field];
        } else if (field === "cidadeView") {
            cityLayer.visible = data[field];
        } else if (field === "cidadeVizinhaView") {
            cityVizinhaLayer.visible = data[field];
        } else if (field === "estadoView") {
            stateLayer.visible = data[field];
            if (cidadeInfo !== null && cidadeInfo.id > 0 &&
                stateLayer.visible && stateLayer.graphics !== null && stateLayer.graphics.items.length === 0) {
                this.findGeometryAreaByEstado(cidadeInfo.estado.id, false);
            }
        }

        this.setState({ data });
    }

    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.showPosition);
            // navigator.geolocation.watchPosition(this.showPosition);
        } else {
            this.show('danger', this.props.t('erros.erro_0061'));
        }
    }

    showPosition(position) {
        loadModules([
            "esri/Graphic",
            "esri/geometry/Point",
            "esri/symbols/PictureMarkerSymbol"], options)
            .then(([Graphic, Point, PictureMarkerSymbol]) => {

                let point = new Point({
                    longitude: parseFloat(position.coords.longitude),
                    latitude: parseFloat(position.coords.latitude)
                });

                gpsLayer.graphics.removeAll();

                gpsLayer.graphics.add(
                    new Graphic({
                        geometry: point,
                        symbol: new PictureMarkerSymbol({
                            url: gpsImg,
                            width: "35px",
                            height: "35px"
                        }),
                    })
                );

                let opts = {
                    duration: 3000
                };

                view.goTo({
                    target: point,
                    zoom: 13
                }, opts).catch((error) => {
                    if (error.name != "AbortError") {
                        console.error(error);
                    }
                });

                // console.log("showPosition:" + "Latitude: " + position.coords.latitude + ", Longitude: " + position.coords.longitude);
            });
    }

    goToPoint(dms = true) {
        let valid = true
        if (dms) {
            dmsValue = dmsValueG_long;
            if (dmsValue === '') {
                this.show('danger', this.props.t('erros.erro_0065'));
                valid = false;
            }
        } else {
            if (this.state.data.xyValue === '') {
                this.show('danger', this.props.t('erros.erro_0066'));
                valid = false;
            }
        }
        if (valid) {
            loadModules([
                "esri/Graphic",
                "esri/geometry/Point",
                "esri/symbols/PictureMarkerSymbol",
                "esri/geometry/projection",
                "esri/geometry/SpatialReference",
                "esri/geometry/coordinateFormatter"], options)
                .then(([Graphic, Point, PictureMarkerSymbol, projection,
                    SpatialReference, coordinateFormatter]) => {

                    dmsValue = dmsValueG_lat + " " + dmsValueM_lat + " " + dmsValueS_lat.replace(",", ".") + dmsValueZ_lat +
                        " " + dmsValueG_long + " " + dmsValueM_long + " " + dmsValueS_long.replace(",", ".") + dmsValueZ_long;

                    let opts = {
                        duration: 3000
                    };

                    let point = null;//Ex: 12 58 17.667S 038 27 42.471W    12 58 17.667 038 27 42.471
                    if (dms) {
                        coordinateFormatter.load().then(function () {
                            let pointRetorno = coordinateFormatter.fromLatitudeLongitude(dmsValue);

                            point = new Point({
                                longitude: pointRetorno.longitude,
                                latitude: pointRetorno.latitude,
                                spatialReference: view.spatialReference
                            });

                            let g = new Graphic(
                                point,
                                new PictureMarkerSymbol({
                                    url: pointImg,
                                    width: "15px",
                                    height: "15px"
                                })
                            );
                            g.attributes = {
                                state: "complete",
                                uid: g.uid,
                                invalid: false,
                                cutted: false
                            };

                            graphicsLayer.graphics.add(g);

                            view.goTo({
                                target: point
                            }, opts).catch((error) => {
                                if (error.name != "AbortError") {
                                    console.error(error);
                                }
                            });
                        });
                    } else {//Ex: -38.45, -12.9
                        let xy = xyValue.split(",");
                        point = new Point({
                            longitude: parseFloat(xy[0]),
                            latitude: parseFloat(xy[1])
                        });

                        let g = new Graphic(
                            point,
                            new PictureMarkerSymbol({
                                url: pointImg,
                                width: "15px",
                                height: "15px"
                            })
                        );
                        g.attributes = {
                            state: "complete",
                            uid: g.uid,
                            invalid: false,
                            cutted: false
                        };

                        graphicsLayer.graphics.add(g);

                        view.goTo({
                            target: point
                        }, opts).catch((error) => {
                            if (error.name != "AbortError") {
                                console.error(error);
                            }
                        });
                    }
                });
        }

    }


    render() {
        const { t } = this.props;

        //API Key = AAPKec03eb92727f4327afe110b4b737126evJFqMoZfbjJv3EvIVav7Ly1lmgs5iOyhzS8OAxW6Uu0-bp9g9jiXmOZGwg66VDsS

        let requerimentoBtn = [];
        let requerimentoLegendBtn = [];
        if (requirement_OK) {
            requerimentoBtn.push(
                <div id="requerimentoBtn" key="requerimentoBtn" className="esri-widget"
                    style={{ width: '310px', height: '245px', padding: '5px', fontSize: '12px', display: 'none' }}>
                    <h4>Requerimento de Área</h4>
                    <div id="requerimentoNameActionBtn" style={{ marginTop: '5px' }}>
                        <Button id="requerimentoSavetBtn" className="icon" color="primary" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginLeft: '5px', width: '90px', float: 'right', marginRight: '5px' }}
                            onClick={e => this.areaRequirementPolygons()}>
                            {t('forms.calculate')}
                        </Button>
                        <Button id="requerimentoSavetBtn" className="icon" color="primary" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginLeft: '5px', width: '90px', float: 'right', marginRight: '5px' }}
                            onClick={e => this.unirRequirementPolygons()}>
                            {t('forms.union')}
                        </Button>
                        <Button className="icon" color="primary" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginRight: '0px', width: '90px', float: 'right' }}
                            onClick={e => this.cortarRequirementPolygons()}>
                            {t('forms.cut')}
                        </Button>
                    </div>
                    <div id="requerimentoNameArea" style={{ marginTop: '35px' }}>
                        <div id="requerimentoNameAreaLabelAcres" className="form__form-group-label" style={{ width: '100%' }}>
                            Acres:
                        </div>
                        <div id="requerimentoNameAreaLabelHc" className="form__form-group-label" style={{ width: '100%' }}>
                            Hectares:
                        </div>
                    </div>
                    <div id="requerimentoNameInput" style={{ marginTop: '0px' }}>
                        <span title={t('forms.requiredField')} className="form__form-group-label">
                            {t('forms.documentName')} <span style={{ color: "#ff0000" }}>*</span>
                        </span>
                        <div>
                            <span className="esri-icon-save" style={{ float: 'left', marginRight: '5px', paddingTop: '3px' }}></span>
                            <input type="text"
                                name="requerimentoNameSave"
                                style={{ width: '160px', height: '25px', verticalAlign: 'middle' }}
                                value={this.state.data.requerimentoNameSave}
                                onChange={e => this.updateField(e)}
                            />
                            <Button id="requerimentoSavetBtn" className="icon" color="primary" type="button"
                                style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginLeft: '5px', width: '90px', float: 'right' }}
                                onClick={e => this.saveRequirementPolygons()}>
                                {t('forms.requireArea')}
                            </Button>
                        </div>
                    </div>
                    <div id="requerimentoSelect" style={{ marginTop: '5px' }}>
                        <span className="form__form-group-label">
                            {t('forms.registrosSalvos')}
                        </span>
                        <div>
                            <div key="requerimentoSelectBorder" style={{ width: '100%', height: '72px', padding: '3px', border: '1px solid #000000' }}>
                                <Select
                                    isMulti="false"
                                    maxMenuHeight="200px"
                                    name="requerimento"
                                    value={this.state.selectedRequirements}
                                    onChange={e => this.updateRequirementsFieldSelect(e)}
                                    options={this.state.requirementsList}
                                    clearable={true}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                />
                                <Button id="requerimentoClearBtn" className="icon" color="primary" type="button"
                                    style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', width: '100%' }}
                                    onClick={e => this.clearRequirements()}>
                                    {t('forms.clear')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        let searchProccess = [];
        if (requirementLayer_OK) {
            requerimentoLegendBtn.push(
                <div id="requerimentoLegendBtn" key="requerimentoLegendBtn" className="esri-widget" style={{ width: '245px', height: '255px', padding: '5px', fontSize: '10px', lineHeight: '8px', display: 'none' }}>
                    <h4>Legenda dos Registros Minerais</h4>
                    <div key="legends" style={{ marginTop: '5px' }}>
                        {/* <div style={{float: 'left', marginBottom: '3px'}}>
              <div style={{float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(0, 191, 255, 0.7)'}}></div>
              <div style={{float: 'left', paddingTop: '3px', paddingLeft: '3px'}}>Apto Para Disponibilidade</div>
            </div> */}

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(250, 196, 165, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Autorização De Pesquisa</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(255, 85, 0, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Concessão De Lavra</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '5px' }}>
                            {/* <div style={{float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(0, 191, 255, 0.7)'}}></div> */}
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(255, 127, 127, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Direito De Requerer A Lavra</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            {/* <div style={{float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(190, 232, 255, 0.7)'}}></div> */}
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(0, 191, 255, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Disponibilidade</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(194, 158, 215, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Lavra Garimpeira</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(120, 62, 97, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Licenciamento</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(168, 112, 0, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Registro De Extração</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(255, 127, 127, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Requerimento De Lavra</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(232, 190, 255, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Requerimento de Lavra Garimpeira</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(211, 255, 190, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Requerimento de Licenciamento</div>
                        </div>

                        <div style={{ clear: 'both', float: 'left', marginBottom: '3px' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(255, 255, 190, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Requerimento de Pesquisa</div>
                        </div>

                        {/* <div style={{clear: 'both', float: 'left', marginBottom: '3px'}}>
              <div style={{float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(215, 194, 158, 0.7)'}}></div>
              <div style={{float: 'left', paddingTop: '3px', paddingLeft: '3px'}}>Requerimento De Registro De Extração</div>
            </div> */}

                        <div style={{ clear: 'both' }}>
                            <div style={{ float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(215, 194, 158, 0.7)' }}></div>
                            <div style={{ float: 'left', paddingTop: '3px', paddingLeft: '3px' }}>Requerimento De Registro De Extração</div>
                        </div>
                        {/* <div style={{clear: 'both'}}>
              <div style={{float: 'left', width: '50px', height: '13px', backgroundColor: 'rgb(0, 191, 255, 0.7)'}}></div>
              <div style={{float: 'left', paddingTop: '3px', paddingLeft: '3px'}}>Dado Não Cadastrado</div>
            </div> */}
                    </div>
                </div>
            );

            searchProccess.push(
                <div id="searchProccessDiv" key="searchProccessDiv" className="esri-widget"
                    style={{ width: '232px', height: '32px', padding: '5px', fontSize: '12px' }}>

                    <div id="searchProccessInput">
                        <span className="form__form-group-label" style={{ float: 'left', paddingTop: '4px' }}>
                            {t('forms.processoAbv')}
                        </span>
                        <div>
                            <input type="text"
                                name="searchProccessValue"
                                style={{ width: '90px', height: '20px', marginLeft: '3px', marginTop: '2px', paddingTop: '2px' }}
                                value={this.state.data.searchProccessValue}
                                onChange={e => this.updateProccessValue(e)}
                            />
                            <Button id="searchProccessBtn" className="icon" color="primary" type="button"
                                style={{ fontSize: '12px', padding: '2px', width: '60px', float: 'right' }}
                                onClick={e => this.searchProccessMap()}>
                                {t('forms.search')}
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }

        let bufferBtn = [];
        if (buffer_OK) {
            bufferBtn.push(
                <div id="bufferBtn" key="bufferBtn" className="esri-widget"
                    style={{ width: '310px', height: '225px', padding: '5px', fontSize: '12px', display: 'none' }}>
                    <div id="infoStatusBufferBtn">
                        <div id="lineStatusBtn" style={{ width: '50%', float: 'left' }}>
                            <h4>Criar Buffer</h4>
                        </div>
                        <div id="bufferStatusBtn" style={{ width: '50%', float: 'left' }}>
                        </div>
                    </div>
                    <div id="bufferSizeInput" style={{ marginTop: '30px' }}>
                        <span title={t('forms.requiredField')} className="form__form-group-label">
                            {t('forms.bufferMeters')} <span style={{ color: "#ff0000" }}>*</span>
                        </span>
                        <div>
                            <span className="esri-icon-measure" style={{ float: 'left', marginRight: '5px', paddingTop: '3px' }}></span>
                            <input type="text"
                                name="bufferSize"
                                style={{ width: '160px', height: '25px', verticalAlign: 'middle' }}
                                value={this.state.data.bufferSize}
                                onChange={e => this.updateBufferField(e)}
                            />
                            <Button id="generaterBufferBtn" className="icon" color="success" type="button"
                                style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginLeft: '5px', width: '90px', float: 'right' }}
                                onClick={e => this.createBufferPolygons()}>
                                {t('forms.generateBuffer')}
                            </Button>
                        </div>
                    </div>
                    <div id="bufferNameInput" style={{ marginTop: '5px' }}>
                        <span title={t('forms.requiredField')} className="form__form-group-label">
                            {t('forms.documentName')} <span style={{ color: "#ff0000" }}>*</span>
                        </span>
                        <div>
                            <span className="esri-icon-save" style={{ float: 'left', marginRight: '5px', paddingTop: '3px' }}></span>
                            <input type="text"
                                name="bufferNameSave"
                                style={{ width: '160px', height: '25px', verticalAlign: 'middle' }}
                                value={this.state.data.bufferNameSave}
                                onChange={e => this.updateField(e)}
                            />
                            <Button id="bufferSavetBtn" className="icon" color="primary" type="button"
                                style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginLeft: '5px', width: '90px', float: 'right' }}
                                onClick={e => this.saveBufferPolygons()}>
                                {t('forms.save')}
                            </Button>
                        </div>
                    </div>
                    <div id="bufferSelect" style={{ marginTop: '5px' }}>
                        <span className="form__form-group-label">
                            {t('forms.registrosSalvos')}
                        </span>
                        <div>
                            <div key="bufferSelectBorder" style={{ width: '100%', height: '72px', padding: '3px', border: '1px solid #000000' }}>
                                <Select
                                    isMulti="false"
                                    maxMenuHeight="200px"
                                    name="buffer"
                                    value={this.state.selectedBuffers}
                                    onChange={e => this.updateBufferFieldSelect(e)}
                                    options={this.state.buffersList}
                                    clearable={true}
                                    className="react-select"
                                    classNamePrefix="react-select"
                                />
                                <Button id="bufferClearBtn" className="icon" color="primary" type="button"
                                    style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', width: '100%' }}
                                    onClick={e => this.clearBuffer()}>
                                    {t('forms.clear')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        let panelHeight = 42;
        let substance_Btn = [];
        if (substance_OK) {
            panelHeight += 66;
            substance_Btn.push(
                <div key="subKey" style={{ marginTop: '5px' }}>
                    <span>Sustâncias</span>
                    <Select
                        isMulti="true"
                        maxMenuHeight="200px"
                        name="subs"
                        value={this.state.selectedSubs}
                        onChange={e => this.updateSubsFieldSelect(e)}
                        options={this.state.subsList}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                    />
                </div>
            );
        }

        let state_Btn = [];
        if (state_OK) {
            panelHeight += 66;
            state_Btn.push(
                <div key="stateKey" style={{ marginTop: '2px' }}>
                    <span>Estados</span>
                    <Select
                        isMulti="false"
                        maxMenuHeight="200px"
                        name="states"
                        value={this.state.selectedStates}
                        onChange={e => this.updateStatesFieldSelect(e)}
                        options={this.state.statesList}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                    />
                </div>
            );
        }

        let city_Btn = [];
        if (city_OK) {
            panelHeight += 66;
            city_Btn.push(
                <div key="cityKey" style={{ marginTop: '2px' }}>
                    <span>Cidades</span>
                    <Select
                        isMulti="false"
                        maxMenuHeight="200px"
                        name="cities"
                        value={this.state.selectedCities}
                        onChange={e => this.updateCitiesFieldSelect(e)}
                        options={this.state.citiesList}
                        clearable={true}
                        className="react-select"
                        classNamePrefix="react-select"
                    />
                </div>
            );
        }

        // let brazil_Btn = [];
        // if(brazil_OK){
        //   panelHeight += 30;
        //   brazil_Btn.push(
        //     <div key="brazilKey" style={{marginTop: '10px'}}>
        //       <input type="checkbox" id="checkboxBrasil"/>
        //       <label htmlFor="checkboxBrasil" style={{paddingLeft: '5px'}}>Ver Brasil Todo</label>
        //     </div>
        //   );
        // }

        let panelSearchBtn = [];
        if (searchPanel_OK) {
            panelSearchBtn.push(
                <div id="panelSearchBtn" key="panelSearchBtn" className="esri-widget" style={{ width: '273px', height: panelHeight + 'px', padding: '5px', fontSize: '12px', display: 'none' }}>
                    <h4>Pesquisar Geologias</h4>
                    {substance_Btn}
                    {state_Btn}
                    {city_Btn}
                    <div id="panelFilterBtn" style={{ marginTop: '5px', textAlign: 'center' }}>
                        <Button className="icon" color="success" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginRight: '5px', width: '60px' }}
                            onClick={e => this.focusBboxPoint(true, false)}>
                            {t('forms.prev')}
                        </Button>
                        <Button className="icon" color="success" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginRight: '5px', width: '60px' }}
                            onClick={e => this.focusBboxPoint(false, true)}>
                            {t('forms.next')}
                        </Button>
                        <Button className="icon" color="primary" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginRight: '5px', width: '60px' }}
                            onClick={e => this.searchGeologies()}>
                            {t('forms.search')}
                        </Button>
                        <Button className="icon" color="primary" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginRight: '0px', width: '60px' }}
                            onClick={e => this.clearGeologyPolygons(false, false)}>
                            {t('forms.clear')}
                        </Button>
                    </div>
                </div>
            );
        }

        let panelSettingBtn = [];
        let panelInfoBtn = [];
        // let popupinfo = this.state.data.popupInfoView ? "esri-icon-visible" : "esri-icon-non-visible";
        let cavernas = this.state.data.cavernasView ? "esri-icon-visible" : "esri-icon-non-visible";
        let sitios = this.state.data.sitiosArqueologicosView ? "esri-icon-visible" : "esri-icon-non-visible";
        let protecao = this.state.data.protecaoIntegralView ? "esri-icon-visible" : "esri-icon-non-visible";
        let quilombolas = this.state.data.quilombolasView ? "esri-icon-visible" : "esri-icon-non-visible";
        let indigenas = this.state.data.terrasIndigenasView ? "esri-icon-visible" : "esri-icon-non-visible";
        let uso = this.state.data.usoSustentavalView ? "esri-icon-visible" : "esri-icon-non-visible";
        let requerimentos = this.state.data.requerimentoView ? "esri-icon-visible" : "esri-icon-non-visible";
        let geologias = this.state.data.geologiaView ? "esri-icon-visible" : "esri-icon-non-visible";
        let geologiasBorda = this.state.data.geologiaBordaView ? "esri-icon-visible" : "esri-icon-non-visible";
        let cidades = this.state.data.cidadeView ? "esri-icon-visible" : "esri-icon-non-visible";
        let cidadesVizinha = this.state.data.cidadeVizinhaView ? "esri-icon-visible" : "esri-icon-non-visible";
        let estados = this.state.data.estadoView ? "esri-icon-visible" : "esri-icon-non-visible";
        if (settingsPanel_OK) {
            panelSettingBtn.push(
                <div id="panelSettingBtn" key="panelSettingBtn" className="esri-widget" style={{ width: '245px', height: '271px', padding: '5px', fontSize: '10px', lineHeight: '8px', display: 'none' }}>
                    <h4>Configurar Visualizações</h4>
                    <div key="settingsRequerimentosKey" style={{ marginTop: '3px' }}>
                        <label key="settingsRequerimentosLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={requerimentos} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("requerimentoView")}> Registros Minerais</span>
                        </label>
                    </div>
                    <div key="settingsGeologiasKey" style={{ marginTop: '0px' }}>
                        <label key="settingsGeologiasLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={geologias} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("geologiaView")}> Geologias</span>
                        </label>
                    </div>
                    <div key="settingsGeologiasBordaKey" style={{ marginTop: '0px' }}>
                        <label key="settingsGeologiasBordaLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={geologiasBorda} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("geologiaBordaView")}> Feições Geológicas</span>
                        </label>
                    </div>
                    <div key="settingsProtecaoKey" style={{ marginTop: '0px' }}>
                        <label key="settingsProtecaoLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={protecao} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("protecaoIntegralView")}> APA Integral</span>
                        </label>
                    </div>
                    <div key="settingsUsoKey" style={{ marginTop: '0px' }}>
                        <label key="settingsUsoLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={uso} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("usoSustentavalView")}> APA de Uso Sustentával</span>
                        </label>
                    </div>
                    <div key="settingsIndigenasKey" style={{ marginTop: '0px' }}>
                        <label key="settingsIndigenasLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={indigenas} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("terrasIndigenasView")}> Terras Indígenas</span>
                        </label>
                    </div>
                    <div key="settingsQuilombolasKey" style={{ marginTop: '0px' }}>
                        <label key="settingsQuilombolasLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={quilombolas} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("quilombolasView")}> Quilombolas</span>
                        </label>
                    </div>
                    <div key="settingsCavernasKey" style={{ marginTop: '0px' }}>
                        <label key="settingsCavernasLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={cavernas} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("cavernasView")}> Cavernas</span>
                        </label>
                    </div>
                    <div key="settingsSitiosKey" style={{ marginTop: '0px' }}>
                        <label key="settingsSitiosLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={sitios} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("sitiosArqueologicosView")}> Sítios Arqueológicos</span>
                        </label>
                    </div>
                    <div key="settingsCidadesKey" style={{ marginTop: '0px' }}>
                        <label key="settingsCidadesLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={cidades} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("cidadeView")}> Cidades</span>
                        </label>
                        <label key="settingsCidadesVizinhaLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={cidadesVizinha} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("cidadeVizinhaView")}> Cidades Vizinhas</span>
                        </label>
                    </div>
                    <div key="settingsEstadosKey" style={{ marginTop: '0px' }}>
                        <label key="settingsEstadosLabelKey" style={{ paddingLeft: '5px', cursor: 'pointer' }}>
                            <span className={estados} style={{ fontSize: '14px' }} onClick={e => this.updateCheckbox("estadoView")}> Estados</span>
                        </label>
                    </div>
                </div>
            );

            if (this.state.data.popupInfoView) {
                // panelInfoBtn.push(
                //   <div key="panelInfoBtn" id="panelInfoBtn" className="esri-widget--button"
                //     style={{backgroundColor: "#6f6f6f", color: "#ffffff"}}
                //     title="Popup com informação dos itens ao clicar mapa">
                //     <span className="esri-icon-description" onClick={e => this.updateCheckbox("popupInfoView")}></span>
                //   </div>
                // );
                panelInfoBtn.push(
                    <div id="panelInfoBtn" key="panelInfoBtn" className="esri-widget"
                        style={{ width: '32px', height: '32px', cursor: 'pointer' }}
                        title="Desativar popup com informação dos itens ao clicar mapa"
                        onClick={e => this.updateCheckbox("popupInfoView")}>
                        <div id="icoInfoDiv" key="icoInfoDiv" style={{ padding: '6px' }}>
                            <img key="infoIcoImg" src={info_01} width="20" height="20"></img>
                        </div>
                    </div>
                );
            } else {
                // panelInfoBtn.push(
                //   <div key="panelInfoBtn" id="panelInfoBtn" className="esri-widget--button"
                //     title="Popup com informação dos itens ao clicar mapa">
                //     <span className="esri-icon-description" onClick={e => this.updateCheckbox("popupInfoView")}></span>
                //   </div>
                // );
                panelInfoBtn.push(
                    <div id="panelInfoBtn" key="panelInfoBtn" className="esri-widget"
                        style={{ width: '32px', height: '32px', cursor: 'pointer' }}
                        title="Ativar popup com informação dos itens ao clicar mapa"
                        onClick={e => this.updateCheckbox("popupInfoView")}>
                        <div id="icoInfoDiv" key="icoInfoDiv" style={{ padding: '6px' }}>
                            <img key="infoIcoImg" src={info_02} width="20" height="20"></img>
                        </div>
                    </div>
                );
            }
        }

        let gpsBtn = [];
        // gpsBtn.push(
        //   <div key="gpsBtn" id="gpsBtn" className="esri-widget--button"
        //     title="Centralizar GPS (localização aproximada)">
        //     <span className="esri-icon-locate" onClick={e => this.centerGPS()}></span>
        //   </div>
        // );

        gpsBtn.push(
            <div id="gpsBtn" key="gpsBtn" className="esri-widget" style={{ width: '245px', height: '250px', padding: '5px', fontSize: '12px', display: 'none' }}>
                <div key="pointDmsDiv">
                    <div style={{ width: '100%' }}>
                        <span>
                            {t('forms.dmsBtnInfo1')}
                            <br />
                            {t('forms.dmsBtnInfo2')}:
                        </span>
                    </div>
                    <div key="dmsPanel1" style={{ width: '100%', height: '148px', padding: '4px', border: '1px solid #000000' }}>
                        <div key="dmsPanel1.1" style={{ width: '100%', height: '30', marginBottom: '3px' }}>
                            <div key="dmsPanel1.1L" style={{ width: '100%', height: '20', marginBottom: '1px', fontSize: '10px' }}>
                                Longitude
                            </div>
                            <div key="dmsPanel1.1select" style={{ width: '100px', float: 'left', marginRight: '3px' }}>
                                <Select
                                    maxMenuHeight="100px"
                                    name="dmsValueZ_long"
                                    value={this.state.selectedLong}
                                    onChange={e => this.updateLongSelect(e)}
                                    options={this.state.longList}
                                />
                            </div>
                            <input type="text"
                                name="dmsValueG_long"
                                style={{ width: '35px', height: '38px', verticalAlign: 'middle', fontSize: '12px', textAlign: 'center', marginRight: '3px' }}
                                value={this.state.data.dmsValueG_long}
                                onChange={e => this.updateFieldDMS(e)}
                            // placeholder="Ex: 12 58 17.667S 038 27 42.471W"
                            />
                            <input type="text"
                                name="dmsValueM_long"
                                style={{ width: '35px', height: '38px', verticalAlign: 'middle', fontSize: '12px', textAlign: 'center', marginRight: '3px' }}
                                value={this.state.data.dmsValueM_long}
                                onChange={e => this.updateFieldDMS(e)}
                            />
                            <input type="text"
                                name="dmsValueS_long"
                                style={{ width: '45px', height: '38px', verticalAlign: 'middle', fontSize: '12px', textAlign: 'center' }}
                                value={this.state.data.dmsValueS_long}
                                onChange={e => this.updateFieldDMS(e)}
                            />
                        </div>
                        <div key="dmsPanel1.2" style={{ width: '100%', height: '30' }}>
                            <div key="dmsPanel1.2L" style={{ width: '100%', height: '20', marginBottom: '1px', fontSize: '10px' }}>
                                Latitude
                            </div>
                            <div key="dmsPanel1.2select" style={{ width: '100px', float: 'left', marginRight: '3px' }}>
                                <Select
                                    maxMenuHeight="100px"
                                    name="dmsValueZ_lat"
                                    value={this.state.selectedLat}
                                    onChange={e => this.updateLatSelect(e)}
                                    options={this.state.latList}
                                />
                            </div>
                            <input type="text"
                                name="dmsValueG_lat"
                                style={{ width: '35px', height: '38px', verticalAlign: 'middle', fontSize: '12px', textAlign: 'center', marginRight: '3px' }}
                                value={this.state.data.dmsValueG_lat}
                                onChange={e => this.updateFieldDMS(e)}
                            />
                            <input type="text"
                                name="dmsValueM_lat"
                                style={{ width: '35px', height: '38px', verticalAlign: 'middle', fontSize: '12px', textAlign: 'center', marginRight: '3px' }}
                                value={this.state.data.dmsValueM_lat}
                                onChange={e => this.updateFieldDMS(e)}
                            />
                            <input type="text"
                                name="dmsValueS_lat"
                                style={{ width: '45px', height: '38px', verticalAlign: 'middle', fontSize: '12px', textAlign: 'center' }}
                                value={this.state.data.dmsValueS_lat}
                                onChange={e => this.updateFieldDMS(e)}
                            />
                        </div>
                        <div key="dmsPanel1.3" style={{ width: '100%', height: '30', marginBottom: '3px' }}>
                            <Button id="dmsBtn" className="icon" color="success" type="button"
                                style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginTop: '3px', width: '100%' }}
                                onClick={e => this.goToPoint(true)}>
                                {t('forms.dmsBtn')}
                            </Button>
                        </div>
                    </div>
                </div>
                {/* <div key="pointXyDiv" style={{marginTop: '5px'}}>
          <span title={t('forms.xyBtnInfoTitle')} style={{float: 'left', width: '105px', marginRight: '5px', paddingTop: '3px'}}>
            {t('forms.xyBtnInfo')}:
          </span>
          <input type="text" 
            name="xyValue"
            style={{width: '200px', height: '25px', verticalAlign: 'middle', fontSize: '10px'}}
            value={this.state.data.xyValue}
            onChange={e => this.updateField(e)}
            placeholder="Ex: -38.45, -12.9"
          />
          <Button id="generaterBufferBtn" className="icon" color="success" type="button" 
            style={{fontSize: '12px', padding: '2px', marginBottom: '0px', marginLeft: '5px', width: '115px', float: 'right'}}
            onClick={e => this.goToPoint(false)}>
            {t('forms.xyBtn')}
          </Button>
        </div> */}
                <div key="gpsDiv" style={{ marginTop: '5px', clear: 'both' }}>
                    <div style={{ width: '100%' }}>
                        <span>
                            {t('forms.gpsBtnInfo')}
                        </span>
                    </div>

                    <div key="gpsPanel1" style={{ width: '100%', height: '50px', padding: '4px' }}>
                        <div key="gpsPanel1.1" style={{ width: '100%', height: '30' }}>
                            <Button id="gpsDivBtn" className="icon" color="success" type="button"
                                style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', width: '100%' }}
                                onClick={e => this.centerGPS()}>
                                {t('forms.gpsBtn')}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );


        let panelCityChangeBtn = [];
        let panelCityChangeVazioBtn = [];
        if (cityChangePanel_OK) {
            panelCityChangeBtn.push(
                <div id="panelCityChangeBtn" key="panelCityChangeBtn" className="esri-widget" style={{ width: '273px', height: '182px', padding: '5px', fontSize: '12px', display: 'none' }}>
                    <h4>Mudar Cidade</h4>
                    <div key="stateChangeKey" style={{ marginTop: '5px' }}>
                        <span>Estados</span>
                        <Select
                            isMulti="false"
                            maxMenuHeight="200px"
                            name="states"
                            value={this.state.selectedStates}
                            onChange={e => this.updateStatesFieldSelect(e)}
                            options={this.state.statesList}
                            clearable={true}
                            className="react-select"
                            classNamePrefix="react-select"
                        />
                    </div>
                    <div key="cityChangeKey" style={{ marginTop: '2px' }}>
                        <span>Cidades</span>
                        <Select
                            isMulti="false"
                            maxMenuHeight="200px"
                            name="cities"
                            value={this.state.selectedCities}
                            onChange={e => this.updateCitiesFieldSelect(e)}
                            options={this.state.citiesList}
                            clearable={true}
                            className="react-select"
                            classNamePrefix="react-select"
                        />
                    </div>
                    <div id="panelCityChangeApplyBtn" style={{ marginTop: '5px', float: 'right' }}>
                        <Button className="icon" color="primary" type="button"
                            style={{ fontSize: '12px', padding: '2px', marginBottom: '0px', marginRight: '0px', width: '60px' }}
                            onClick={e => this.changeCity()}>
                            {t('forms.apply')}
                        </Button>
                    </div>
                </div>
            );
            panelCityChangeVazioBtn.push(
                <div key="panelCityChangeVazioBtn" id="panelCityChangeVazioBtn" style={{ opacity: 0 }}>
                    <span >empty</span>
                </div>
            );
            // panelCityChangeVazioBtn.push(
            //   <div key="panelCityChangeVazio2Btn" id="panelCityChangeVazio2Btn" style={{opacity: 0}}>
            //       <span >empty</span>
            //   </div>
            // );
        }

        let panelCityInfoBtn = [];
        if (cityInfoPanel_OK) {
            panelCityInfoBtn.push(
                <div id="panelCityInfoBtn" key="panelCityInfoBtn" className="esri-widget" style={{ width: '500px', height: '112px', padding: '5px', fontSize: '12px', display: 'none' }}>
                    <h4>{cidadeInfo !== null ? cidadeInfo.name + " - " + cidadeInfo.estado.uf : 'Cidade não informada!'}</h4>
                    <div>
                        <ul>
                            <li>Prefeito: {cidadeInfo !== null ? cidadeInfo.prefeito + " (" + cidadeInfo.siglaPartidoPrefeito + ")" : ""}</li>
                            <li>Vice-Prefeito: {cidadeInfo !== null ? cidadeInfo.vicePrefeito + " (" + cidadeInfo.siglaPartidoVicePrefeito + ")" : ""}</li>
                            <li>Clima: {(cidadeInfo !== null && cidadeInfo.clima != null && cidadeInfo.clima.id > 0 ? cidadeInfo.clima.name : '')}</li>
                            <li>Descrição clima: {(cidadeInfo !== null && cidadeInfo.descriptionClima != null && cidadeInfo.descriptionClima.length > 0 ? cidadeInfo.descriptionClima : (cidadeInfo !== null && cidadeInfo.clima != null && cidadeInfo.clima.id > 0 ? cidadeInfo.clima.description : ''))}</li>
                            <li>{(cidadeInfo !== null && cidadeInfo.nivelHabilitadoLicenciamento > 0 ? "Município Habilitado Competência Municipal nível " + cidadeInfo.nivelHabilitadoLicenciamento : "Município não Habilitado")}</li>
                        </ul>
                    </div>
                </div>
            );
        }

        let dmsPanel = [];
        dmsPanel.push(
            <div id="dmsPanelDiv" key="dmsPanelDiv" className="esri-widget"
                style={{ width: '185px', height: '32px', padding: '5px', fontFamily: 'Helvetica Neue', fontSize: '10px' }}>
                <div id="coordinateString" key="coordinateString" style={{ paddingTop: '4px' }}>DMS: </div>
            </div>
        );

        let loadingIco = [];
        loadingIco.push(
            <div id="loadingIcoCenter" key="loadingIcoCenter" className="esri-widget"
                style={{ position: 'absolute', bottom: '50%', right: '40%', width: '50px', height: '50px', backgroundColor: 'transparent', boxShadow: 'none', display: 'none' }}>
                <div id="loadingIcoDivCenter" key="loadingIcoDivCenter">
                    <img key="loadingIcoImgCenter" src={loadingImg} width="50" height="50"></img>
                </div>
            </div>
        );
        loadingIco.push(
            <div id="loadingIco" key="loadingIco" className="esri-widget"
                style={{ position: 'absolute', bottom: '120px', right: '11px', width: '40px', height: '40px', backgroundColor: 'transparent', boxShadow: 'none' }}>
                <div id="loadingIcoDiv" key="loadingIcoDiv">
                    <img key="loadingIcoImg" src={loadingImg} width="40" height="40"></img>
                </div>
            </div>
        );

        return (
            <>
                <div id='viewDiv' style={styles.container}>
                    {requerimentoBtn}
                    {searchProccess}
                    {requerimentoLegendBtn}
                    {bufferBtn}
                    {panelSearchBtn}
                    {panelSettingBtn}
                    {panelInfoBtn}
                    {gpsBtn}
                    {panelCityChangeBtn}
                    {panelCityChangeVazioBtn}
                    {panelCityInfoBtn}
                    {dmsPanel}
                    {loadingIco}
                    <div id="changeBaseMapDiv"></div>
                </div>
            </>
        );
    }
}

export default withTranslation('common')(ArcGisMap);